/*
 * サブシステム名
 * 機能名：受注・実績登録
 */

import { mapGetters } from 'vuex'
import complements from '@/rahmen/complement'
import date from '@/ddv2.library/date'
import dayjs from 'dayjs'
import d2fmt from '@/ddv2.library/utils/formatter'
// import d2dt from '@/ddv2.library/utils/datetime'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import fraction from '@/ddv2.library/fraction'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'

import DdCustomButton from '@/components/DdCustomButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdDateBox from '@/components/DdDateBox'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdJitsuUnsoTaiseiKanriEdit from '@/components/DdJitsuUnsoTaiseiKanriEdit'

// import dayjs from 'dayjs'
// import tax from '@/ddv2.library/tax'

const DdCalcDistance = () => import('@/components/DdCalcDistance.vue')
const DdCalcTankaBox = () => import('@/components/DdCalcTankaBox')
const DdCalcTankaButton = () => import('@/components/DdCalcTankaButton.vue')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdCodeTextBoxSwitch = () => import('@/components/DdCodeTextBoxSwitch')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdJuchuHimozukeSearchButton = () => import('@/components/DdJuchuHimozukeSearchButton')
const DdJuchuRirekiSearchButton = () => import('@/components/DdJuchuRirekiSearchButton')
const DdNumericBox = () => import('@/components/DdNumericBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTeikeiCorseSearchButton = () => import('@/components/DdTeikeiCorseSearchButton')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBox = () => import('@/components/DdTimeBox')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const ThKoteiKamotsuNoTextBox = () => import('@/components/ThKoteiKamotsuNoTextBox')

export default {
  name: 'HaisoMeisaiEdit',
  mixins: [flowMixin],
  components: {
    DdCalcDistance,
    DdCalcTankaBox,
    DdCalcTankaButton,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitch,
    DdCustomButton,
    DdDataTable,
    DdDateBox,
    DdDefaultButton,
    DdDropDown,
    DdEditCommonBar,
    DdIconButtonWithTooltip,
    DdJuchuHimozukeSearchButton,
    DdJuchuRirekiSearchButton,
    DdJitsuUnsoTaiseiKanriEdit,
    DdNumericBox,
    DdRadioButton,
    DdSectionTitle,
    DdSubHeader,
    DdSwitch,
    DdTeikeiCorseSearchButton,
    DdTextArea,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdTimeBox,
    DdTimeBoxSwitching,
    DdTransparentButton,
    ThKoteiKamotsuNoTextBox
  },
  data: () => ({
    viewTitleX: '作業実績登録（設定中）',
    id: 0,
    baseYmd: '',
    keikakujissekikey: '',
    trJuchuKihonId: 0,
    haishaEigyoshoCd: '',
    jiEigyoshoId: 0,
    dispJisshaRitsu: 0,
    nenryoCount: 0,
    tsukoryoCount: 0,
    jishaSharyoSbt: null,
    yoshaSharyoSbt: null,
    invalidMessages: {},
    copyMode: false,
    // 画面ピクセル制御用
    widthOfLineHeader: [0, 0, 0],
    // ----------------------------------------------------------------------------------------------------
    // 必須制御
    // ----------------------------------------------------------------------------------------------------
    isRequiredCommon: true,
    isRequiredJomuin: false,
    isRequiredJoshu: false,
    isRequiredSharyo: false,
    isRequiredYosha: false,
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    viewsData: {
      vwUnkoJisseki: {},
      vwSagyoJisseki: {},
      vwKintaiJissekiJomuin: {},
      vwKintaiJissekiJoshu: {},
      vwHaisoMeisai: [{}],
      trSagyoKeikakuJininList: [{}],
      trSagyoKeikakuMeisaiList: [{}],
      vwSharyoKeihiNenryohi: [{}],
      vwSharyoKeihiTsukoryo: [{}]
    },
    tempViewsData: {},
    /*
     * 乗務員・車両情報編集用定義
     */
    lastUnkoJissekiInfo: {},
    /*
     * 配送明細編集用定義
     */
    recTokuisakiInfo: {},
    recHaisoMeisai: {},
    tempHaisoMeisai: {},
    selectPopUpCondtion: {},
    /*
     * 経費編集画面用定義
     */
    recNenryo: {},
    tempNenryo: {},
    recTsukoryo: {},
    tempTsukoryo: {},
    // ----------------------------------------------------------------------------------------------------
    // タブ定義
    // ----------------------------------------------------------------------------------------------------
    tab: [
      { href: '#tab1', value: '配送明細' },
      { href: '#tab2', value: '燃料' },
      { href: '#tab3', value: '通行料' }
    ],
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    registerMode: 0,
    deleteMode: 0,
    modeKengen: 0,
    modeOfEdit: 0,
    haisoMeisaiEditIndex: -1,
    nenryoEditIndex: -1,
    tsukoryoEditIndex: -1,
    isJishaHaishaMode: true,
    isJiEigyoshoMode: true,
    isHokaEigyoshoMode: false,
    isHaisoMeisaiRequired: false,
    expandKeiyuchi: false,
    CancelButtonDisp: true,
    DeleteButtonDisp: false,
    NewButtonDisp: true,
    SaveButtonDisp: true,
    kakuninzumiMode: false,
    seikyuZumiMode: false,
    shiharaiZumiMode: false,
    initializeMode: false,
    initializeDispMode: true,

    // ----------------------------------------------------------------------------------------------------
    // データテーブル用定義
    // ----------------------------------------------------------------------------------------------------
    haisoMeisaiListHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      // { text: '', value: 'selectRow' },
      { text: '操作', value: 'actions', width: '155px', sortable: false },
      { text: '#', value: 'meisaiOrder', width: '40px' },
      // { text: '請求年月日', value: 'dispSeikyuYoteiYmd', align: 'center' },
      // { text: '得意先', value: 'dispTokuisaki' },
      { text: '商品', value: 'dispHinmei' },
      { text: '発地', value: 'dispHatsuchi' },
      { text: '着地', value: 'dispChakuchi' },
      { text: '単価', value: 'tanka', width: '50px' },
      { text: '数量', value: 'juchuSuryo', width: '50px' },
      { text: '費用区分', value: 'ShunyuKbn', width: '50px' },
      { text: '補助CD', value: 'ShunyuHojoCd', width: '40px' },
      { text: '請求金額', value: 'dispSeikyuKingaku', align: 'right' },
      { text: '傭車先', value: 'dispHacchusaki' },
      { text: '費用区分', value: 'HiyoKbn', width: '50px' },
      { text: '補助CD', value: 'HiyoHojoCd', width: '40px' },
      { text: '支払金額', value: 'dispShiharaiKingaku', align: 'right' }
      // { text: '注文番号', value: 'chumonNo' }
    ]
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      usersId: 'users/userId',
      currentKaishaCode: 'users/currentKaishaCode',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      teikeiCourseList: 'DDMasters/vwCD2mstd0460',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'users/helpUseFlg',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const self = this
      return self.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn !== '03' && t.eigyoshoCd === self.haishaEigyoshoCd
      })
    },
    filteredEigyoshoGroupJininList () {
      const self = this
      return self.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn !== '03' && t.eigyoshoCd === self.haishaEigyoshoCd
      })
    },
    filteredYoshaJininList () {
      const self = this
      return self.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn === '03'
      })
    },
    // 人員マスタフィルター <-- ここまで
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const self = this
      return self.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const self = this
      return self.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const self = this
      return self.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === true
      })
    },
    filteredMstShiiresakiList () {
      const self = this
      return self.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.shiiresakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      return self.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === false && t.eigyoshoCd === self.haishaEigyoshoCd
      })
    },
    filteredMstYoshaSharyoList () {
      const self = this
      return self.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const self = this
      return self.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 品名マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 定型コースフィルター --> ここから
    filteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Nm : elem.keiyuchiBiko1
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.yoshaUnchinHokaKingaku) { elem.yoshaUnchinHokaKingaku = filter.numericFormatter(elem.yoshaUnchinHokaKingaku) }
        if (elem.yoshaUnchinHokaHikazei) { elem.yoshaUnchinHokaHikazei = filter.numericFormatter(elem.yoshaUnchinHokaHikazei) }
        if (elem.shiharaiGokei) { elem.shiharaiGokei = filter.numericFormatter(elem.shiharaiGokei) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    },
    // 定型コースフィルター <-- ここまで

    // 作業区分フィルタ
    filteredSagyoKbnList () {
      var defArray = [
        { value: null, text: '未選択' },
        { value: 'Y01', text: '輸送' },
        { value: 'X99', text: 'EX' }
      ]
      return defArray
    },
    // 就労区分フィルター
    filteredShuroKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF999')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 燃料区分フィルター
    filteredNenryoKubunList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    },
    // 支払種別フィルター
    filteredShiharaiShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT021')
    },
    // 往復種別フィルター
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      var unchinKeisanKbnList = this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
      return unchinKeisanKbnList.filter((item) => {
        return ['01', '02', '03'].includes(item.value)
      })
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    // 課税区分
    filteredKazeiKbnList () {
      return this.sbtListFilterForDropDownItem(this.kubunList, 'SFF059')
    },
    // 端数処理区分
    filteredHasuKeisanKbnList () {
      return this.sbtListFilterForDropDownItem(this.kubunList, 'SFF060')
    },
    // 配送明細フィルター --> ここから
    filteredHaisoMeisaiListRows () {
      // データがない場合の制御
      if (!this.viewsData.vwHaisoMeisai.map) { return }

      return this.viewsData.vwHaisoMeisai.map((elem, index) => {
        // 行番号
        elem.rowNo = index + 1

        elem.dispHatsuchi = ''
        elem.dispChakuchi = ''
        elem.dispHinmei = ''

        if (elem.meisaiOrder) { elem.meisaiOrder = Number(elem.meisaiOrder) }
        if (elem.tokuisakiId) {
          const record = indexeddb.getRecord(this.torihikisakiList, elem.tokuisakiId)
          elem.dispTokuisaki = record ? record.torihikisakiNm : ''
        }
        if (![undefined, null, ''].includes(elem.hatsuchiId)) {
          const record = indexeddb.getRecord(this.hacchakuchiList, elem.hatsuchiId)
          elem.dispHatsuchi = record ? record.hacchakuchiNm : ''
        }
        if (![undefined, null, ''].includes(elem.hatsuchiBiko)) { elem.dispHatsuchi = elem.dispHatsuchi + (elem.dispHatsuchi !== '' ? ' ' : '') + elem.hatsuchiBiko }
        if (elem.hatsuchiYmd || elem.hatsuchiHms) { elem.dispHatsuchiYmd = !elem.hatsuchiYmd ? elem.hatsuchiHms : !elem.hatsuchiHms ? elem.hatsuchiYmd : elem.hatsuchiYmd + ' ' + elem.hatsuchiHms }
        if (elem.hatsuchiHmsBiko && !(elem.hatsuchiYmd || elem.hatsuchiHms)) { elem.dispHatsuchiYmd = elem.hatsuchiHmsBiko }
        if (![undefined, null, ''].includes(elem.chakuchiId)) {
          const record = indexeddb.getRecord(this.hacchakuchiList, elem.chakuchiId)
          elem.dispChakuchi = record ? record.hacchakuchiNm : ''
        }
        if (![undefined, null, ''].includes(elem.chakuchiBiko)) { elem.dispChakuchi = elem.dispChakuchi + (elem.dispChakuchi !== '' ? ' ' : '') + elem.chakuchiBiko }
        if (elem.chakuchiYmd || elem.chakuchiHms) { elem.dispChakuchiYmd = !elem.chakuchiYmd ? elem.chakuchiHms : !elem.chakuchiHms ? elem.chakuchiYmd : elem.chakuchiYmd + ' ' + elem.chakuchiHms }
        if (elem.chakuchiHmsBiko && !(elem.chakuchiYmd || elem.chakuchiHms)) { elem.dispChakuchiYmd = elem.chakuchiHmsBiko }
        if (![undefined, null, ''].includes(elem.mstHinmeiId)) {
          const record = indexeddb.getRecord(this.hinmeiList, elem.mstHinmeiId)
          elem.dispHinmei = record ? record.hinmeiNm : ''
        }
        if (![undefined, null, ''].includes(elem.hinmeiBiko)) { elem.dispHinmei = elem.dispHinmei + (elem.dispHinmei !== '' ? ' ' : '') + elem.hinmeiBiko }
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericMinorDigitFormatter(elem.juchuSuryo, 3) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericMinorDigitFormatter(elem.juchuJuryo, 3) }
        if (elem.seikyuYoteiYmd) { elem.dispSeikyuYoteiYmd = elem.seikyuYoteiYmd }

        // 基本運賃
        let amount = 0
        let tanka = 0
        if (elem.tanka) { tanka = elem.tanka }
        if (elem.unchinKeisanKbn === '01') {
          let juchuSuryo = elem.juchuSuryo
          if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }
          juchuSuryo = d2fmt.removeComma(juchuSuryo)
          amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
        } else if (elem.unchinKeisanKbn === '02') {
          let juchuJuryo = elem.juchuJuryo
          if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }
          juchuJuryo = d2fmt.removeComma(juchuJuryo)
          amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
        } else if (elem.unchinKeisanKbn === '03') {
          amount = parseFloat(tanka, 10)
        }
        if (elem.hiwayPrice) { amount += parseFloat(elem.hiwayPrice, 10) }
        if (elem.unchinHokaKingaku) { amount += parseFloat(elem.unchinHokaKingaku, 10) }
        if (elem.unchinHokaHikazei) { amount += parseFloat(elem.unchinHokaHikazei, 10) }
        if (elem.nenryoSurcharge) { amount += parseFloat(elem.nenryoSurcharge, 10) }
        if (elem.tsumikomiKingaku) { amount += parseFloat(elem.tsumikomiKingaku, 10) }
        if (elem.torioroshiKingaku) { amount += parseFloat(elem.torioroshiKingaku, 10) }
        if (elem.taikiJikanKingaku) { amount += parseFloat(elem.taikiJikanKingaku, 10) }
        if (elem.futaiGyomuKingaku) { amount += parseFloat(elem.futaiGyomuKingaku, 10) }
        if (elem.jikanWarimashiKingaku) { amount += parseFloat(elem.jikanWarimashiKingaku, 10) }
        if (elem.kyoriWarimashiKingaku) { amount += parseFloat(elem.kyoriWarimashiKingaku, 10) }
        if (elem.warimashiSonotaKingsku) { amount += parseFloat(elem.warimashiSonotaKingsku, 10) }
        elem.dispSeikyuKingaku = filter.numericFormatter(amount)
        let payAmount = 0
        if (elem.yoshaKihonUnchin) { payAmount += parseFloat(elem.yoshaKihonUnchin, 10) }
        if (elem.yoshaHiwayPrice) { payAmount += parseFloat(elem.yoshaHiwayPrice, 10) }
        if (elem.yoshaUnchinHokaKingaku) { payAmount += parseFloat(elem.yoshaUnchinHokaKingaku, 10) }
        if (elem.yoshaUnchinHokaHikazei) { payAmount += parseFloat(elem.yoshaUnchinHokaHikazei, 10) }
        elem.dispShiharaiKingaku = filter.numericFormatter(payAmount)
        elem.dispChumonshoReceiveZumiFlg = elem.chumonshoReceiveZumiFlg ? '受領済' : ''
        elem.dispChumonkakuninshoSendZumiFlg = elem.chumonkakuninshoSendZumiFlg ? '送付済' : ''
        elem.dispHacchushoSendZumiFlg = elem.hacchushoSendZumiFlg ? '送付済' : ''
        elem.dispMotoukeHokokuZumiFlg = elem.motoukeHokokuZumiFlg ? '報告済' : ''
        return elem
      }).sort((a, b) => {
        if (a.meisaiOrder > b.meisaiOrder) { return 1 }
        if (a.meisaiOrder === b.meisaiOrder) { return 0 }
        return -1
      })
    },
    seikyuKingakuSummary () {
      let amount = 0
      this.viewsData.vwHaisoMeisai.map((elem) => {
        let tanka = 0
        if (elem.tanka) { tanka = elem.tanka }
        if (elem.unchinKeisanKbn === '01') {
          let juchuSuryo = elem.juchuSuryo
          if ([undefined, null, ''].includes(juchuSuryo)) { juchuSuryo = '0' }
          juchuSuryo = d2fmt.removeComma(juchuSuryo)
          amount += parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
        } else if (elem.unchinKeisanKbn === '02') {
          let juchuJuryo = elem.juchuJuryo
          if ([undefined, null, ''].includes(juchuJuryo)) { juchuJuryo = '0' }
          juchuJuryo = d2fmt.removeComma(juchuJuryo)
          amount += parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
        } else if (elem.unchinKeisanKbn === '03') {
          amount += parseFloat(tanka, 10)
        }
        if (elem.hiwayPrice) { amount += parseFloat(elem.hiwayPrice, 10) }
        if (elem.unchinHokaKingaku) { amount += parseFloat(elem.unchinHokaKingaku, 10) }
        if (elem.unchinHokaHikazei) { amount += parseFloat(elem.unchinHokaHikazei, 10) }
        if (elem.nenryoSurcharge) { amount += parseFloat(elem.nenryoSurcharge, 10) }
        if (elem.tsumikomiKingaku) { amount += parseFloat(elem.tsumikomiKingaku, 10) }
        if (elem.torioroshiKingaku) { amount += parseFloat(elem.torioroshiKingaku, 10) }
        if (elem.taikiJikanKingaku) { amount += parseFloat(elem.taikiJikanKingaku, 10) }
        if (elem.futaiGyomuKingaku) { amount += parseFloat(elem.futaiGyomuKingaku, 10) }
        if (elem.jikanWarimashiKingaku) { amount += parseFloat(elem.jikanWarimashiKingaku, 10) }
        if (elem.kyoriWarimashiKingaku) { amount += parseFloat(elem.kyoriWarimashiKingaku, 10) }
        if (elem.warimashiSonotaKingsku) { amount += parseFloat(elem.warimashiSonotaKingsku, 10) }
      })
      return filter.numericFormatter(amount)
    },
    // 配送明細フィルター <-- ここまで
    // 燃料行データ
    nenryohiRows () {
      // データがない場合の制御
      if (!this.viewsData.vwSharyoKeihiNenryohi) return

      return this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
        if (elem.tekiyo5) { elem.tekiyo5 = Number(elem.tekiyo5) }

        if (elem.torihikisakiId) {
          elem.wTorihikisakiCdNm = indexeddb.getRecord(this.torihikisakiList, elem.torihikisakiId).torihikisakiCd + ':' + indexeddb.getRecord(this.torihikisakiList, elem.torihikisakiId).torihikisakiNm
        }
        if (elem.fuelKbn) {
          elem.wFuelKbnNm = elem.fuelKbnNm !== -1 ? elem.fuelKbn + ' : ' + indexeddb.getKubun(this.currentKaishaCode, this.kubunList, 'SFF053', elem.fuelKbn).codeNm : ''
        }
        if (elem.tekiyo3) {
          elem.wShiharaiKbnNm = elem.shiharaiKbnNm !== -1 ? elem.tekiyo3 + ' : ' + indexeddb.getShubetsu(this.currentKaishaCode, this.shubetsuList, 'SBT021', elem.tekiyo3).sbtNm : ''
        }
        if (elem.suryo) {
          elem.suryo = filter.numericFormatter(String(elem.suryo))
        }
        if (elem.keihiTanka) {
          elem.keihiTanka = filter.numericFormatter(String(elem.keihiTanka))
        }
        if (elem.keihiKingaku) {
          elem.keihiKingaku = filter.numericFormatter(String(elem.keihiKingaku))
        }
        return elem
      }).sort((a, b) => {
        if (a.tekiyo5 > b.tekiyo5) { return 1 }
        if (a.tekiyo5 === b.tekiyo5) { return 0 }
        return -1
      })
    },
    // 通行料行データ
    tsukoryoRows () {
      // データがない場合の制御
      if (!this.viewsData.vwSharyoKeihiTsukoryo) return

      return this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
        if (elem.tekiyo5) { elem.tekiyo5 = Number(elem.tekiyo5) }

        if (elem.tekiyo3) {
          elem.wShiharaiKbnNm = elem.shiharaiKbnNm !== -1 ? elem.tekiyo3 + ' : ' + indexeddb.getShubetsu(this.currentKaishaCode, this.shubetsuList, 'SBT021', elem.tekiyo3).sbtNm : ''
        }
        if (elem.suryo) {
          elem.suryo = filter.numericFormatter(String(elem.suryo))
        }
        if (elem.keihiKingaku) {
          elem.keihiKingaku = filter.numericFormatter(String(elem.keihiKingaku))
        }

        return elem
      }).sort((a, b) => {
        if (a.tekiyo5 > b.tekiyo5) { return 1 }
        if (a.tekiyo5 === b.tekiyo5) { return 0 }
        return -1
      })
    },
    calcJisshaRitsu () {
      let rate = 0
      let sokoKyori = this.viewsData.vwUnkoJisseki.sokoKyori
      let jisshaKyori = this.viewsData.vwUnkoJisseki.jisshaKyori

      if (sokoKyori === undefined || sokoKyori === '' || sokoKyori === null) { sokoKyori = 0 }
      if (jisshaKyori === undefined || jisshaKyori === '' || jisshaKyori === null) { jisshaKyori = 0 }

      if (sokoKyori === 0) { return rate }
      rate = (parseFloat(jisshaKyori * 10, 10) / parseFloat(sokoKyori * 10, 10)) * 100
      rate = rate === 0 ? 0 : Math.round(rate * 10) / 10

      return rate
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.recHaisoMeisai.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.recHaisoMeisai.unchinKeisanKbn === '01') {
        let juchuSuryo = this.recHaisoMeisai.juchuSuryo
        if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }
        juchuSuryo = d2fmt.removeComma(juchuSuryo)
        amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
      } else if (this.recHaisoMeisai.unchinKeisanKbn === '02') {
        let juchuJuryo = this.recHaisoMeisai.juchuJuryo
        if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }
        juchuJuryo = d2fmt.removeComma(juchuJuryo)
        amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
      } else if (this.recHaisoMeisai.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }
      amount = this.calcFraction(amount)
      return amount
    },
    unchinKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hokanKingaku = this.recHaisoMeisai.hokanKingaku
      let niekiKingaku = this.recHaisoMeisai.niekiKingaku
      let unchinHokaKingaku = this.recHaisoMeisai.unchinHokaKingaku
      let nenryoSurcharge = this.recHaisoMeisai.nenryoSurcharge
      let tsumikomiKingaku = this.recHaisoMeisai.tsumikomiKingaku
      let torioroshiKingaku = this.recHaisoMeisai.torioroshiKingaku
      let taikiJikanKingaku = this.recHaisoMeisai.taikiJikanKingaku
      let futaiGyomuKingaku = this.recHaisoMeisai.futaiGyomuKingaku

      if (hokanKingaku === undefined || hokanKingaku === '' || hokanKingaku === null) { hokanKingaku = '0' }
      if (niekiKingaku === undefined || niekiKingaku === '' || niekiKingaku === null) { niekiKingaku = '0' }
      if (unchinHokaKingaku === undefined || unchinHokaKingaku === '' || unchinHokaKingaku === null) { unchinHokaKingaku = '0' }
      if (nenryoSurcharge === undefined || nenryoSurcharge === '' || nenryoSurcharge === null) { nenryoSurcharge = '0' }
      if (tsumikomiKingaku === undefined || tsumikomiKingaku === '' || tsumikomiKingaku === null) { tsumikomiKingaku = '0' }
      if (torioroshiKingaku === undefined || torioroshiKingaku === '' || torioroshiKingaku === null) { torioroshiKingaku = '0' }
      if (taikiJikanKingaku === undefined || taikiJikanKingaku === '' || taikiJikanKingaku === null) { taikiJikanKingaku = '0' }
      if (futaiGyomuKingaku === undefined || futaiGyomuKingaku === '' || futaiGyomuKingaku === null) { futaiGyomuKingaku = '0' }

      let amount = 0

      amount = parseInt(this.calcUnchin, 10) +
                parseInt(hokanKingaku, 10) +
                parseInt(niekiKingaku, 10) +
                parseInt(unchinHokaKingaku, 10) +
                parseInt(nenryoSurcharge, 10) +
                parseInt(tsumikomiKingaku, 10) +
                parseInt(torioroshiKingaku, 10) +
                parseInt(taikiJikanKingaku, 10) +
                parseInt(futaiGyomuKingaku, 10)

      return amount
    },
    hikazeiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let hiwayPrice = this.recHaisoMeisai.hiwayPrice
      let unchinHokaHikazei = this.recHaisoMeisai.unchinHokaHikazei
      let tatekaekinHikazei = this.recHaisoMeisai.tatekaekinHikazei

      if (hiwayPrice === undefined || hiwayPrice === '' || hiwayPrice === null) { hiwayPrice = '0' }
      if (unchinHokaHikazei === undefined || unchinHokaHikazei === '' || unchinHokaHikazei === null) { unchinHokaHikazei = '0' }
      if (tatekaekinHikazei === undefined || tatekaekinHikazei === '' || tatekaekinHikazei === null) { tatekaekinHikazei = '0' }

      let amount = 0

      amount = parseInt(hiwayPrice, 10) + parseInt(unchinHokaHikazei, 10) + parseInt(tatekaekinHikazei, 10)

      return amount
    },
    warimashiKingakuAmount () {
      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let jikanWarimashiKingaku = this.recHaisoMeisai.jikanWarimashiKingaku
      let kyoriWarimashiKingaku = this.recHaisoMeisai.kyoriWarimashiKingaku
      let warimashiSonotaKingsku = this.recHaisoMeisai.warimashiSonotaKingsku

      if (jikanWarimashiKingaku === undefined || jikanWarimashiKingaku === '' || jikanWarimashiKingaku === null) { jikanWarimashiKingaku = '0' }
      if (kyoriWarimashiKingaku === undefined || kyoriWarimashiKingaku === '' || kyoriWarimashiKingaku === null) { kyoriWarimashiKingaku = '0' }
      if (warimashiSonotaKingsku === undefined || warimashiSonotaKingsku === '' || warimashiSonotaKingsku === null) { warimashiSonotaKingsku = '0' }

      let amount = 0

      amount = parseInt(jikanWarimashiKingaku, 10) + parseInt(kyoriWarimashiKingaku, 10) + parseInt(warimashiSonotaKingsku, 10)

      return amount
    },
    unchinAddWarimashiKingakuAmout () {
      let amount = 0

      amount = parseInt(this.unchinKingakuAmount, 10) + parseInt(this.warimashiKingakuAmount, 10)

      return amount
    },
    calcSeikyuKingakuAmount () {
      let amount = 0
      // const hasuKeisanKbn = this.recTokuisakiInfo.unchinHasuKeisanKbn ? this.recTokuisakiInfo.unchinHasuKeisanKbn : '02'

      if (this.hikazeiKingakuAmount > 0 || this.unchinAddWarimashiKingakuAmout > 0) {
        amount = parseInt(this.hikazeiKingakuAmount, 10) + parseInt(this.unchinAddWarimashiKingakuAmout, 10)
        // amount = this.hikazeiKingakuAmount + tax.calcTaxToIncluded(this.unchinAddWarimashiKingakuAmout, hasuKeisanKbn, new Date())
      }

      return amount
    },
    calcShiharaiKingakuAmount () {
      let amount = 0

      amount = 0

      // 配送明細が存在しない場合
      if ([undefined, null].includes(this.recHaisoMeisai) || this.recHaisoMeisai.length === 0) { return 0 }

      let yoshaKihonUnchin = this.recHaisoMeisai.yoshaKihonUnchin
      let yoshaHiwayPrice = this.recHaisoMeisai.yoshaHiwayPrice
      let yoshaUnchinHokaKingaku = this.recHaisoMeisai.yoshaUnchinHokaKingaku
      let yoshaUnchinHokaHikazei = this.recHaisoMeisai.yoshaUnchinHokaHikazei

      if (yoshaKihonUnchin === undefined || yoshaKihonUnchin === '' || yoshaKihonUnchin === null) { yoshaKihonUnchin = '0' }
      if (yoshaHiwayPrice === undefined || yoshaHiwayPrice === '' || yoshaHiwayPrice === null) { yoshaHiwayPrice = '0' }
      if (yoshaUnchinHokaKingaku === undefined || yoshaUnchinHokaKingaku === '' || yoshaUnchinHokaKingaku === null) { yoshaUnchinHokaKingaku = '0' }
      if (yoshaUnchinHokaHikazei === undefined || yoshaUnchinHokaHikazei === '' || yoshaUnchinHokaHikazei === null) { yoshaUnchinHokaHikazei = '0' }

      amount = parseInt(yoshaKihonUnchin, 10) + parseInt(yoshaHiwayPrice, 10) + parseInt(yoshaUnchinHokaKingaku, 10) + parseInt(yoshaUnchinHokaHikazei, 10)

      return amount
    },

    /**
     * 処理中行
     */
    currentRowNo () {
      if (![undefined, null].includes(this.recHaisoMeisai.rowNo)) {
        return this.recHaisoMeisai.rowNo
      } else if (this.filteredHaisoMeisaiListRows.length > 0 && this.recHaisoMeisai.trJuchuKihonId > 0) {
        const targetIndex = this.filteredHaisoMeisaiListRows.findIndex(function (elem) {
          return elem.trJuchuKihonId === Number(this.recHaisoMeisai.trJuchuKihonId)
        })
        return targetIndex + 1
      } else {
        return 1
      }
    },

    // 処理中作業明細IDリスト
    selectedTrSagyoMeisaiIds () {
      const tsmIdList = [
        ...(this.viewsData?.vwHaisoMeisai ?? []).map(x => x.tsmId),
        this.recHaisoMeisai?.tsmId
      ].filter(v => v != null && v !== '')

      return tsmIdList
    },

    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.kakuninzumiMode && !this.seikyuZumiMode && !this.shiharaiZumiMode && this.id > 0) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2 && this.id > 0) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyKakuninzumiFlg () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode) {
        return true
      }
      return false
    },
    isReadOnlySeikyuzumi () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode || this.recHaisoMeisai.seikyuZumiFlg) {
        return true
      }
      return false
    },
    isReadOnlyShiharaizumi () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode || this.recHaisoMeisai.shiharaiZumiFlg) {
        return true
      }
      return false
    },

    isSharyoInputModeManual () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03' && ![undefined, null, ''].includes(this.viewsData.vwUnkoJisseki.sharyoId)) {
        return false
      } else {
        return this.getUserSettings
      }
    },
    isHinmeiInputModeManual () {
      if (![undefined, null, ''].includes(this.recHaisoMeisai.mstHinmeiId)) {
        return false
      } else {
        return this.getUserSettings
      }
    },
    isHatsuchiInputModeManual () {
      if (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiId)) {
        return false
      } else {
        return this.getUserSettings
      }
    },
    isKeiyuchiInputModeManual () {
      if (![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1)) {
        return false
      } else {
        return this.getUserSettings
      }
    },
    isChakuchiInputModeManual () {
      if (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiId)) {
        return false
      } else {
        return this.getUserSettings
      }
    },
    isMapDisable () {
      if (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiId) ||
          ![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiBiko) ||
          ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) ||
          ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko1) ||
          ![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiId) ||
          ![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiBiko)) {
        return false
      }
      return true
    },
    tableWidthStyle () {
      const bgc = 'white'
      const bgch = '#eeeeee'
      return {
        '--width-of-1': this.widthOfLineHeader[0] + 'px',
        '--width-of-2': this.widthOfLineHeader[1] + 'px',
        '--width-of-3': this.widthOfLineHeader[2] + 'px',
        '--backcolor': bgc,
        '--backcolor-hover': bgch
      }
    },
    getUserSettings () {
      const self = this
      if ([undefined, null].includes(self.userSettings)) {
        return true
      } else if ([true, 'true'].includes(self.userSettings.defaultInputManualFlg)) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    // 遷移元情報
    // this.setFromParameters(this.$route.params.id)
  },
  mounted () {
    console.log('mounted', this.steps)
    this.initialize()
  },
  watch: {
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        viewsData: this.viewsData,
        recHaisoMeisai: this.recHaisoMeisai,
        recNenryo: this.recNenryo,
        recTsukoryo: this.recTsukoryo,
        nenryoCount: this.nenryoCount,
        tsukoryoCount: this.tsukoryoCount
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        let path = ''
        if (self.id > 0) {
          path = `/api/v1/D2PRMD0020/JuchuWithJissekiSearch?id=${self.id}`
        } else {
          path = `/api/v1/D2PRMD0020/InitJuchuWithJissekiGetbyKeikakuInfo?key=${self.keikakujissekikey}`
          // 計画は考慮しない為日報では参照せずに終了する
          // resolve()
        }
        self.HttpClient
          .get(path)
          .then((data) => {
            if (data.payload) {
              const inputData = {}
              inputData.vwUnkoJisseki = data.payload.vwUnkoJisseki
              if (inputData.vwUnkoJisseki.haishaKbn === '01') { inputData.vwUnkoJisseki.haishaKbn = '02' }
              self.id = inputData.vwUnkoJisseki.id
              inputData.vwSagyoJisseki = data.payload.vwSagyoJisseki
              self.kakuninzumiMode = Boolean(inputData.vwSagyoJisseki.jissekiKakuninZumiFlg)
              if (data.payload.vwKintaiJissekiJomuin) {
                inputData.vwKintaiJissekiJomuin = data.payload.vwKintaiJissekiJomuin
                if ((inputData.vwKintaiJissekiJomuin.shukkinYms)) {
                  inputData.vwKintaiJissekiJomuin.shukkinYms = filter.dateFormatter(inputData.vwKintaiJissekiJomuin.shukkinYms)
                }
                if ((inputData.vwKintaiJissekiJomuin.shukkinHms)) {
                  inputData.vwKintaiJissekiJomuin.shukkinHms = complements.parseTime(inputData.vwKintaiJissekiJomuin.shukkinHms, false).substr(0, 5)
                }
                if ((inputData.vwKintaiJissekiJomuin.taikinYms)) {
                  inputData.vwKintaiJissekiJomuin.taikinYms = filter.dateFormatter(inputData.vwKintaiJissekiJomuin.taikinYms)
                }
                if ((inputData.vwKintaiJissekiJomuin.taikinHms)) {
                  inputData.vwKintaiJissekiJomuin.taikinHms = complements.parseTime(inputData.vwKintaiJissekiJomuin.taikinHms, false).substr(0, 5)
                }
                if (inputData.vwKintaiJissekiJomuin.kosokuJikan === 0) {
                  inputData.vwKintaiJissekiJomuin.kosokuJikan = '0'
                }
                if (inputData.vwKintaiJissekiJomuin.kyukeiJikan === 0) {
                  inputData.vwKintaiJissekiJomuin.kyukeiJikan = '0'
                }
                if (inputData.vwKintaiJissekiJomuin.kadouJikan === 0) {
                  inputData.vwKintaiJissekiJomuin.kadouJikan = '0'
                }
              } else {
                inputData.vwKintaiJissekiJomuin = {
                  jininId: '',
                  shukkinYms: null,
                  shukkinHms: null,
                  taikinYms: null,
                  taikinHms: null,
                  kosokuJikan: null,
                  kyukeiJikan: null,
                  kadouJikan: null,
                  kinmuTeateKingaku1: null,
                  kinmuTeateKingaku2: null,
                  kinmuTeateKingaku3: null,
                  kinmuTeateKingaku4: null,
                  kinmuTeateKingaku5: null
                }
              }
              if (data.payload.vwKintaiJissekiJoshu) {
                inputData.vwKintaiJissekiJoshu = data.payload.vwKintaiJissekiJoshu
                if ((inputData.vwKintaiJissekiJoshu.shukkinYms)) {
                  inputData.vwKintaiJissekiJoshu.shukkinYms = filter.dateFormatter(inputData.vwKintaiJissekiJoshu.shukkinYms)
                }
                if ((inputData.vwKintaiJissekiJoshu.shukkinHms)) {
                  inputData.vwKintaiJissekiJoshu.shukkinHms = complements.parseTime(inputData.vwKintaiJissekiJoshu.shukkinHms, false).substr(0, 5)
                }
                if ((inputData.vwKintaiJissekiJoshu.taikinYms)) {
                  inputData.vwKintaiJissekiJoshu.taikinYms = filter.dateFormatter(inputData.vwKintaiJissekiJoshu.taikinYms)
                }
                if ((inputData.vwKintaiJissekiJoshu.taikinHms)) {
                  inputData.vwKintaiJissekiJoshu.taikinHms = complements.parseTime(inputData.vwKintaiJissekiJoshu.taikinHms, false).substr(0, 5)
                }
                if (inputData.vwKintaiJissekiJoshu.kosokuJikan === 0) {
                  inputData.vwKintaiJissekiJoshu.kosokuJikan = '0'
                }
                if (inputData.vwKintaiJissekiJoshu.kyukeiJikan === 0) {
                  inputData.vwKintaiJissekiJoshu.kyukeiJikan = '0'
                }
                if (inputData.vwKintaiJissekiJoshu.kadouJikan === 0) {
                  inputData.vwKintaiJissekiJoshu.kadouJikan = '0'
                }
              } else {
                inputData.vwKintaiJissekiJoshu = {
                  jininId: '',
                  shukkinYms: null,
                  shukkinHms: null,
                  taikinYms: null,
                  taikinHms: null,
                  kosokuJikan: null,
                  kyukeiJikan: null,
                  kadouJikan: null,
                  kinmuTeateKingaku1: null,
                  kinmuTeateKingaku2: null,
                  kinmuTeateKingaku3: null,
                  kinmuTeateKingaku4: null,
                  kinmuTeateKingaku5: null
                }
              }
              if (data.payload.vwHaisoMeisai) {
                inputData.vwHaisoMeisai = data.payload.vwHaisoMeisai
                var seikyuZumi = inputData.vwHaisoMeisai.find((t) => {
                  return t.seikyuZumiFlg === true
                })
                self.seikyuZumiMode = Boolean(seikyuZumi)

                var shiharaiZumi = inputData.vwHaisoMeisai.find((t) => {
                  return t.shiharaiZumiFlg === true
                })
                self.shiharaiZumiMode = Boolean(shiharaiZumi)

                inputData.vwHaisoMeisai.forEach((elem) => {
                  elem.dispJitsuUnsoTaiseiKanriList = Object.assign([], elem.jitsuUnsoTaiseiKanriList)
                })
              } else {
                inputData.vwHaisoMeisai = []
              }
              if (data.payload.trSagyoKeikakuJininList) {
                inputData.trSagyoKeikakuJininList = data.payload.trSagyoKeikakuJininList
              } else {
                inputData.trSagyoKeikakuJininList = []
              }
              if (data.payload.trSagyoKeikakuMeisaiList) {
                inputData.trSagyoKeikakuMeisaiList = data.payload.trSagyoKeikakuMeisaiList
              } else {
                inputData.trSagyoKeikakuMeisaiList = []
              }
              if (data.payload.vwSharyoKeihiNenryohi) {
                self.nenryoCount = data.payload.nenryoCount
                inputData.vwSharyoKeihiNenryohi = data.payload.vwSharyoKeihiNenryohi
              } else {
                inputData.vwSharyoKeihiNenryohi = []
              }
              if (data.payload.vwSharyoKeihiTsukoryo) {
                self.tsukoryoCount = data.payload.tsukoryoCount
                inputData.vwSharyoKeihiTsukoryo = data.payload.vwSharyoKeihiTsukoryo
              } else {
                inputData.vwSharyoKeihiTsukoryo = []
              }
              self.viewsData = Object.assign({}, inputData)
              self.inputOdoMater()
              self.inputJissekiKyori()
              // this.calcJikanWarimashiKingaku()
              // this.calcKyoriWarimashiKingaku()
              self.convertToDispType().then(() => {
                self.cloneData = dolly.clone(self.getCloneTargetMethod())
              })
              if (self.viewsData.vwHaisoMeisai.length > 0) {
                const selectedHaisiMeisai = self.viewsData.vwHaisoMeisai.filter(function (elem) {
                  return elem.id === Number(self.trJuchuKihonId)
                })
                if (selectedHaisiMeisai.length > 0) {
                  self.onMeisaiEditOpenButtonClick(selectedHaisiMeisai[0])
                } else {
                  self.onMeisaiEditOpenButtonClick(self.viewsData.vwHaisoMeisai[0])
                }
              }

              self.baseYmd = self.viewsData.vwUnkoJisseki.unkoYmd
            } else {
              self.id = 0
              self.keikakujissekikey = '0'
              self.trJuchuKihonId = 0
              // modals.showToastMessage('COMI0101', null, 500, null, 'info')
            }
            if (self.seikyuZumiMode) {
              modals.showToastMessage('RCOI0006', null, 500, null, 'info')
            }
            if (!self.seikyuZumiMode && self.shiharaiZumiMode) {
              modals.showToastMessage('PLOI0006', null, 500, null, 'info')
            }
            resolve()
          })
      })
    },
    initialize () {
      this.setFromParameters(this.$route.params.id).then((e) => {
        const self = this
        const option = {
          loadMasters: ['vwcmsteigyoshojininlist', 'msteigyosho', 'msttorihikisaki', 'vwcmstsharyo', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu', 'vwcd2mstd0460'],
          initializeInputPromise: () => {
            return new Promise((resolve) => {
              self.initBindVariables()
              console.log('initializeInputPromise')
              resolve()
            })
          },
          savedInputRestorePromise: (c) => {
            return new Promise((resolve) => {
              // ユーザ保存項目の復元
              self.rec = { ...self.rec, ...c }
              resolve()
            })
          },
          existsIdMethod: () => {
            return !(self.id === 0 && self.keikakujissekikey === '0')
          },
          requestApiPromise: self.fetchData,
          settingButtonStatePromise: (kengen) => {
            return new Promise((resolve) => {
              console.log('settingButtonStatePromise', kengen)
              if (kengen.kengenKbn === '10') {
                // 読取モード
                self.modeKengen = 0
              } else if (kengen.kengenKbn === '20') {
                // 削除不可モード
                self.modeKengen = 1
              } else {
                // フルアクセス
                self.modeKengen = 2
              }
              // thisId == 0 then 新規モード
              if (self.id === 0) {
                self.modeOfEdit = 0 // 新規モード
              } else if (this.modeKengen === 0) {
                self.modeOfEdit = 1 // 照会モード
              } else {
                self.modeOfEdit = 2 // 更新モード
              }
              self.$refs.dispJitsuUnsoTaiseiKanriListComponent.setJitsuUnsoTaiseiKanriHeader()
              self.$nextTick(() => {
                document.getElementById('heavy-element').style.display = ''
                self.calcWidthLineHeader()
                this.initializeDispMode = false
              })

              resolve()
            })
          },
          settingItemMethod: (kengen) => {
            console.log('settingItemMethod', kengen)
          }
        }
        console.info('call initializeForRegister', this.initializeForRegister, option)
        this.initializeForRegister(option)
      })
    },
    changeHaishaKbn: function (e) {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.tab = '#tab1'
      }
    },
    inputIraisakiEigyosho: function () {
      if (!this.viewsData.vwSagyoJisseki.eigyoshoId) { return }
      this.$set(this, 'haishaEigyoshoCd', indexeddb.getRecord(this.eigyoshoList, this.viewsData.vwSagyoJisseki.eigyoshoId).eigyoshoCd)
    },
    inputOdoMater: function () {
      if (!this.viewsData.vwUnkoJisseki.sokoKyori && this.viewsData.vwUnkoJisseki.hatsuchiOdoMater && this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
        let hatsuchiOdoMater = this.viewsData.vwUnkoJisseki.hatsuchiOdoMater
        let chakuchiOdoMater = this.viewsData.vwUnkoJisseki.chakuchiOdoMater

        if (hatsuchiOdoMater === undefined || hatsuchiOdoMater === '' || hatsuchiOdoMater === null) { hatsuchiOdoMater = 0 }
        if (chakuchiOdoMater === undefined || chakuchiOdoMater === '' || chakuchiOdoMater === null) { chakuchiOdoMater = 0 }

        const calcSokoKyori = Math.floor(fraction.calcSubtract(parseFloat(chakuchiOdoMater), parseFloat(hatsuchiOdoMater)) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'sokoKyori', calcSokoKyori)
      }
    },
    inputJissekiKyori: function () {
      let sokoKyori = this.viewsData.vwUnkoJisseki.sokoKyori
      let jisshaKyori = this.viewsData.vwUnkoJisseki.jisshaKyori
      let kushaKyori = this.viewsData.vwUnkoJisseki.kushaKyori

      if (sokoKyori === undefined || sokoKyori === '' || sokoKyori === null) { sokoKyori = 0 }
      if (jisshaKyori === undefined || jisshaKyori === '' || jisshaKyori === null) { jisshaKyori = 0 }
      if (kushaKyori === undefined || kushaKyori === '' || kushaKyori === null) { kushaKyori = 0 }

      let calcKyori = 0

      if (!this.viewsData.vwUnkoJisseki.jisshaKyori && this.viewsData.vwUnkoJisseki.sokoKyori && this.viewsData.vwUnkoJisseki.kushaKyori) {
        calcKyori = Math.floor(fraction.calcSubtract(sokoKyori, kushaKyori) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'jisshaKyori', calcKyori)
      } else if (!this.viewsData.vwUnkoJisseki.kushaKyori && this.viewsData.vwUnkoJisseki.sokoKyori && this.viewsData.vwUnkoJisseki.jisshaKyori) {
        calcKyori = Math.floor(fraction.calcSubtract(sokoKyori, jisshaKyori) * 10) / 10
        this.$set(this.viewsData.vwUnkoJisseki, 'kushaKyori', calcKyori)
      }
    },
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.recHaisoMeisai.taikiJikan
      let taikiJikanTanka = this.recHaisoMeisai.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.recHaisoMeisai, 'taikiJikanKingaku', taikiJikanKingaku)
    },
    calcJikanWarimashiKingaku: function () {
      let warimashiTaishoJikan = this.recHaisoMeisai.warimashiTaishoJikan
      let warimashiJikanTanka = this.recHaisoMeisai.warimashiJikanTanka

      if (warimashiTaishoJikan === undefined || warimashiTaishoJikan === '' || warimashiTaishoJikan === null) { warimashiTaishoJikan = '00:00' }
      if (warimashiJikanTanka === undefined || warimashiJikanTanka === '' || warimashiJikanTanka === null) { warimashiJikanTanka = 0 }

      warimashiTaishoJikan = filter.timeToMinFormatter(warimashiTaishoJikan)
      const jikanWarimashiKingaku = Math.round((warimashiTaishoJikan / 60) * warimashiJikanTanka)
      this.$set(this.recHaisoMeisai, 'jikanWarimashiKingaku', jikanWarimashiKingaku)
    },
    calcKyoriWarimashiKingaku: function () {
      let warimashiTaishoKyori = this.recHaisoMeisai.warimashiTaishoKyori
      let warimashiKyoriTanka = this.recHaisoMeisai.warimashiKyoriTanka

      if (warimashiTaishoKyori === undefined || warimashiTaishoKyori === '' || warimashiTaishoKyori === null) { warimashiTaishoKyori = 0 }
      if (warimashiKyoriTanka === undefined || warimashiKyoriTanka === '' || warimashiKyoriTanka === null) { warimashiKyoriTanka = 0 }

      const kyoriWarimashiKingaku = Math.round(warimashiTaishoKyori * warimashiKyoriTanka)
      this.$set(this.recHaisoMeisai, 'kyoriWarimashiKingaku', kyoriWarimashiKingaku)
    },
    calcFraction: function (x) {
      if ([undefined, null, ''].includes(this.recTokuisakiInfo) || [undefined, null, ''].includes(this.recTokuisakiInfo.unchinHasuKeisanKbn)) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.recTokuisakiInfo.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    },
    // ----------------------------------------------------------------------------------------------------
    // 前回帰庫時オドメーター取得
    // ----------------------------------------------------------------------------------------------------
    // 車両IDが入力されたら、最終運行実績情報取得メソッドを呼ぶ
    changeCarInfo: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn !== '03') {
        if (!this.viewsData.vwUnkoJisseki.sharyoId) { return }
        console.log('changeCarInfo')
        this.jishaSharyoSbt = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId).shashuSbt
        this.recHaisoMeisai.seikyuShashuSbt = this.jishaSharyoSbt
      } else {
        if (!this.viewsData.vwUnkoJisseki.sharyoId) { return }
        this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId).shashuSbt
        this.setYoshaInfo()
      }
    },
    compareDateTimeJomuin: function () {
      var msg
      this.$refs.shukkinYmd1[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.shukkinHms1[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.taikinYmd1[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.taikinHms1[this.Ctrls.SET_INVALID_METHOD](undefined)

      if (this.viewsData.vwKintaiJissekiJomuin.shukkinYmd && this.viewsData.vwKintaiJissekiJomuin.taikinYmd) {
        msg = validators.compareDate(this.viewsData.vwKintaiJissekiJomuin.shukkinYmd, this.viewsData.vwKintaiJissekiJomuin.taikinYmd)
        if (msg !== undefined) {
          this.$refs.shukkinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwKintaiJissekiJomuin.shukkinYmd && this.viewsData.vwKintaiJissekiJomuin.shukkinHms && this.viewsData.vwKintaiJissekiJomuin.taikinYmd && this.viewsData.vwKintaiJissekiJomuin.taikinHms) {
        msg = validators.compareDateTime(this.viewsData.vwKintaiJissekiJomuin.shukkinYmd, this.viewsData.vwKintaiJissekiJomuin.shukkinHms, this.viewsData.vwKintaiJissekiJomuin.taikinYmd, this.viewsData.vwKintaiJissekiJomuin.taikinHms)
        if (msg !== undefined) {
          this.$refs.shukkinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shukkinHms1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd1[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinHms1[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    inputAttendanceTimesElementJomuin: function () {
      if (this.initializeDispMode) { return }
      if (this.compareDateTimeJomuin()) {
        // 出庫帰庫年月日時刻より、拘束・残業・深夜・深夜残・休憩時間を算出する。
        if (this.viewsData.vwKintaiJissekiJomuin.jininId > 0 &&
            this.viewsData.vwKintaiJissekiJomuin.shukkinYmd &&
            this.viewsData.vwKintaiJissekiJomuin.shukkinHms &&
            this.viewsData.vwKintaiJissekiJomuin.taikinYmd &&
            this.viewsData.vwKintaiJissekiJomuin.taikinHms
        ) {
          this.calculationAttendanceTimes(this.usersId, this.viewsData.vwKintaiJissekiJomuin.shukkinYmd ?? '', this.viewsData.vwKintaiJissekiJomuin.shukkinHms ?? '', this.viewsData.vwKintaiJissekiJomuin.taikinYmd ?? '', this.viewsData.vwKintaiJissekiJomuin.taikinHms, this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan ?? '')
            .then((res) => {
              const jomuinKintaiInfo = Object.assign({}, this.viewsData.vwKintaiJissekiJomuin)
              jomuinKintaiInfo.kosokuJikan = res.kosokuJikan ? (res.kosokuJikan).slice(0, 5) : null
              jomuinKintaiInfo.kadouJikan = res.kadouJikan ? (res.kadouJikan).slice(0, 5) : null
              jomuinKintaiInfo.zangyoJikan = res.zangyoJikan ? (res.zangyoJikan).slice(0, 5) : null
              jomuinKintaiInfo.shinyaJikan = res.shinyaJikan ? (res.shinyaJikan).slice(0, 5) : null
              jomuinKintaiInfo.shinyaZangyoJikan = res.shinyaZangyoJikan ? (res.shinyaZangyoJikan).slice(0, 5) : null
              jomuinKintaiInfo.kyukeiJikan = res.kyukeiJikan ? (res.kyukeiJikan).slice(0, 5) : null
              this.viewsData.vwKintaiJissekiJomuin = Object.assign({}, jomuinKintaiInfo)
            })
        }
      }
    },
    compareDateTimeJoshu: function () {
      var msg
      this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.shukkinHms2[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.taikinYmd2[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.taikinHms2[this.Ctrls.SET_INVALID_METHOD](undefined)

      if (this.viewsData.vwKintaiJissekiJoshu.shukkinYmd && this.viewsData.vwKintaiJissekiJoshu.taikinYmd) {
        msg = validators.compareDate(this.viewsData.vwKintaiJissekiJoshu.shukkinYmd, this.viewsData.vwKintaiJissekiJoshu.taikinYmd)
        if (msg !== undefined) {
          this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwKintaiJissekiJoshu.shukkinYmd && this.viewsData.vwKintaiJissekiJoshu.shukkinHms && this.viewsData.vwKintaiJissekiJoshu.taikinYmd && this.viewsData.vwKintaiJissekiJoshu.taikinHms) {
        msg = validators.compareDateTime(this.viewsData.vwKintaiJissekiJoshu.shukkinYmd, this.viewsData.vwKintaiJissekiJoshu.shukkinHms, this.viewsData.vwKintaiJissekiJoshu.taikinYmd, this.viewsData.vwKintaiJissekiJoshu.taikinHms)
        if (msg !== undefined) {
          this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shukkinHms2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.taikinHms2[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    inputAttendanceTimesElementJoshu: function () {
      if (this.compareDateTimeJoshu()) {
        // 出庫帰庫年月日時刻より、拘束・残業・深夜・深夜残・休憩時間を算出する。
        if (this.viewsData.vwKintaiJissekiJoshu.jininId > 0 &&
          this.viewsData.vwKintaiJissekiJoshu.shukkinYmd &&
          this.viewsData.vwKintaiJissekiJoshu.shukkinHms &&
          this.viewsData.vwKintaiJissekiJoshu.taikinYmd &&
          this.viewsData.vwKintaiJissekiJoshu.taikinHms
        ) {
          this.calculationAttendanceTimes(this.usersId, this.viewsData.vwKintaiJissekiJoshu.shukkinYmd ?? '', this.viewsData.vwKintaiJissekiJoshu.shukkinHms ?? '', this.viewsData.vwKintaiJissekiJoshu.taikinYmd ?? '', this.viewsData.vwKintaiJissekiJoshu.taikinHms ?? '', this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan ?? '')
            .then((res) => {
              const joshuKintaiInfo = Object.assign({}, this.viewsData.vwKintaiJissekiJoshu)
              joshuKintaiInfo.kosokuJikan = res.kosokuJikan ? (res.kosokuJikan).slice(0, 5) : null
              joshuKintaiInfo.kadouJikan = res.kadouJikan ? (res.kadouJikan).slice(0, 5) : null
              joshuKintaiInfo.zangyoJikan = res.zangyoJikan ? (res.zangyoJikan).slice(0, 5) : null
              joshuKintaiInfo.shinyaJikan = res.shinyaJikan ? (res.shinyaJikan).slice(0, 5) : null
              joshuKintaiInfo.shinyaZangyoJikan = res.shinyaZangyoJikan ? (res.shinyaZangyoJikan).slice(0, 5) : null
              joshuKintaiInfo.kyukeiJikan = res.kyukeiJikan ? (res.kyukeiJikan).slice(0, 5) : null
              this.viewsData.vwKintaiJissekiJoshu = Object.assign({}, joshuKintaiInfo)
            })
        }
      }
    },
    calculationAttendanceTimes: function (loginId, shukkoYmd, shukkoHms, kikoYmd, kikoHms, kyukei) {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/ApiLibrary/CalculationAttendanceTimes?id=${loginId}&shukkinYmdString=${shukkoYmd}&shukkinHmsString=${shukkoHms}&taikinYmdString=${kikoYmd}&taikinHmsString=${kikoHms}&kyukeiString=${kyukei}`)
          .then((data) => {
            resolve(data.payload)
          })
      })
    },
    compareDateTimeOperation: function () {
      var msg
      this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](undefined)

      if (this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && this.viewsData.vwUnkoJisseki.jissekiKikoYmd) {
        msg = validators.compareDate(this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoYmd)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwUnkoJisseki.jissekiShukkoYmd && this.viewsData.vwUnkoJisseki.jissekiShukkoHms && this.viewsData.vwUnkoJisseki.jissekiKikoYmd && this.viewsData.vwUnkoJisseki.jissekiKikoHms) {
        msg = validators.compareDateTime(this.viewsData.vwUnkoJisseki.jissekiShukkoYmd, this.viewsData.vwUnkoJisseki.jissekiShukkoHms, this.viewsData.vwUnkoJisseki.jissekiKikoYmd, this.viewsData.vwUnkoJisseki.jissekiKikoHms)
        if (msg !== undefined) {
          this.$refs.shukkinYmd2[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    // 車種設定
    setSeikyuShashuSbt: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.recHaisoMeisai.seikyuShashuSbt = this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 得意先IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeTokuisaki: function () {
      // 履歴検索用受注営業所コード設定
      this.selectPopUpCondtion.tokuisakiId = this.recHaisoMeisai.tokuisakiId

      if (!this.recHaisoMeisai.tokuisakiId) { return }
      console.log('changeTokuisakiId')
      const tokuisakiInfo = indexeddb.getRecord(this.torihikisakiList, this.recHaisoMeisai.tokuisakiId)
      this.recHaisoMeisai.torihikisakiCd = tokuisakiInfo ? tokuisakiInfo.torihikisakiCd : ''
      if (this.recHaisoMeisai.motoukeFlg) {
        this.$set(this.recHaisoMeisai, 'maninushiNm', tokuisakiInfo ? tokuisakiInfo.torihikisakiNm : '')
        if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
          this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputManinushiNm()
        }
      }
      this.getTokuisakiInfo(this.recHaisoMeisai.tokuisakiId)
    },
    getTokuisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2PRMD0020/TokuisakiInfoFind?id=${this.recHaisoMeisai.tokuisakiId}`)
          .then((data) => {
            this.recTokuisakiInfo = data.payload
            console.log('getTokuisakiInfo', this.recTokuisakiInfo)
            this.initSeikyuYoteiYmd()
            this.recHaisoMeisai.unchinKeisanKbn = this.recHaisoMeisai.unchinKeisanKbn ? this.recHaisoMeisai.unchinKeisanKbn : this.recTokuisakiInfo.unchinKeisanKbn
            this.recHaisoMeisai.warimashiJikanTanka = this.recHaisoMeisai.warimashiJikanTanka ? this.recHaisoMeisai.warimashiJikanTanka : this.recTokuisakiInfo.warimashiJikanTanka
            this.recHaisoMeisai.warimashiKyoriTanka = this.recHaisoMeisai.warimashiKyoriTanka ? this.recHaisoMeisai.warimashiKyoriTanka : this.recTokuisakiInfo.warimashiKyoriTanka
          })
        resolve()
      })
    },
    initSeikyuYoteiYmd: function () {
      if (this.initializeMode) {
        this.initializeMode = false
        return
      }
      const keijobiKbn = this.recTokuisakiInfo.keijobiKbn

      if (keijobiKbn === undefined || keijobiKbn === '') { return }
      /*
      if (this.recHaisoMeisai.seikyuYoteiYmd !== filter.dateFormatter(new Date()) && !this.recHaisoMeisai.meisaiOrder) { return }

      if (this.recHaisoMeisai.seikyuYoteiYmd && this.recHaisoMeisai.meisaiOrder) { return }
      */
      if (keijobiKbn === '1' && ![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd)) {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.hatsuchiYmd)
      } else if (keijobiKbn === '2' && ![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiYmd)) {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.chakuchiYmd)
      } else {
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.viewsData.vwUnkoJisseki.unkoYmd)
      }
    },
    // コースNo反映ボタン押下
    // ----------------------------------------------------------------------------------------------------
    // ポップアップから選択時
    // 反映ボタン押下時
    teikeiCourseNoSync: function () {
      if (!this.recHaisoMeisai.teikeiKihonNo) { return }
      var teikeiInfo = this.getTeikeiInfo(this.recHaisoMeisai.teikeiKihonNo)
      this.teikeiCourseNoDialogSync(teikeiInfo)
    },
    // ポップアップから選択時
    teikeiCourseNoDialogSync: function (elem) {
      let initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: elem.teikeiKihonNo,
        chumonNo: elem.chumonNo,
        tokuisakiId: elem.tokuisakiId,
        mstHinmeiId: elem.mstHinmeiId,
        hinmeiBiko: elem.hinmeiBiko,
        hatsuchiId: elem.hatsuchiId,
        hatsuchiBiko: elem.hatsuchiBiko,
        hatsuchiHms: elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : null,
        hatsuchiHmsBiko: elem.hatsuchiHmsBiko,
        keiyuchiId1: elem.keiyuchiId1,
        keiyuchiBiko1: elem.keiyuchiBiko1,
        chakuchiId: elem.chakuchiId,
        chakuchiBiko: elem.chakuchiBiko,
        chakuchiHms: elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : null,
        chakuchiHmsBiko: elem.chakuchiHmsBiko,
        unchinKeisanKbn: elem.unchinKeisanKbn,
        seikyuShashuSbt: elem.seikyuShashuSbt,
        juchuSuryo: d2fmt.removeComma(elem.juchuSuryo),
        unitKbn: ![undefined, null, ''].includes(elem.unitKbn) ? elem.unitKbn : null,
        juchuJuryo: d2fmt.removeComma(elem.juchuJuryo),
        tanka: d2fmt.removeComma(elem.tanka),
        hiwayPrice: d2fmt.removeComma(elem.hiwayPrice),
        unchinHokaKingaku: d2fmt.removeComma(elem.unchinHokaKingaku),
        unchinHokaHikazei: d2fmt.removeComma(elem.unchinHokaHikazei),
        nenryoSurcharge: d2fmt.removeComma(elem.nenryoSurcharge),
        tsumikomiKingaku: d2fmt.removeComma(elem.tsumikomiKingaku),
        torioroshiKingaku: d2fmt.removeComma(elem.torioroshiKingaku),
        taikiJikan: elem.taikiJikanDisp,
        taikiJikanTanka: d2fmt.removeComma(elem.taikiJikanTanka),
        taikiJikanKingaku: d2fmt.removeComma(elem.taikiJikanKingaku),
        futaiGyomuKingaku: d2fmt.removeComma(elem.futaiGyomuKingaku),
        jikanWarimashiKingaku: d2fmt.removeComma(elem.jikanWarimashiKingaku),
        kyoriWarimashiKingaku: d2fmt.removeComma(elem.unchinHokaHikazei),
        warimashiSonotaKingsku: d2fmt.removeComma(elem.warimashiSonotaKingaku),
        seikyuBiko: elem.seikyuBiko,
        yoshaKihonUnchin: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchin) : null,
        yoshaHiwayPrice: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaHiwayPrice) : null,
        yoshaUnchinHokaKingaku: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchinHokaKingaku) : null,
        yoshaUnchinHokaHikazei: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchinHokaHikazei) : null,
        shiharaiBiko: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? elem.shiharaiBiko : null
      }
      this.setInitHaisoMeisai(initHaisoMeisai)
      initHaisoMeisai = undefined
    },
    selectJuchuHimozukeInfo: function (e) {
      this.selectJuchuRirekiInfo(e, 'himozuke')
    },
    selectJuchuRirekiInfo: function (e, m) {
      console.log(e)
      if (!e) { return }
      let initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: e.teikeiKihonNo,
        chumonNo: e.chumonNo,
        tokuisakiId: e.tokuisakiId,
        mstHinmeiId: e.mstHinmeiId,
        hinmeiBiko: e.hinmeiBiko,
        hatsuchiId: e.hatsuchiId,
        hatsuchiBiko: e.hatsuchiBiko,
        hatsuchiHms: e.hatsuchiHms ? e.hatsuchiHmsDisp : null,
        hatsuchiHmsBiko: e.hatsuchiHmsBiko,
        keiyuchiId1: e.keiyuchiId1,
        keiyuchiBiko1: e.keiyuchiBiko1,
        chakuchiId: e.chakuchiId,
        chakuchiBiko: e.chakuchiBiko,
        chakuchiHms: e.chakuchiHms ? e.chakuchiHmsDisp : null,
        chakuchiHmsBiko: e.chakuchiHmsBiko,
        unchinKeisanKbn: e.unchinKeisanKbn,
        seikyuShashuSbt: e.seikyuShashuSbt,
        juchuSuryo: e.juchuSuryo,
        unitKbn: ![undefined, null, ''].includes(e.unitKbn) ? e.unitKbn : null,
        juchuJuryo: e.juchuJuryo,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        unchinHokaKingaku: e.unchinHokaKingaku,
        unchinHokaHikazei: e.unchinHokaHikazei,
        nenryoSurcharge: e.nenryoSurcharge,
        tsumikomiKingaku: e.tsumikomiKingaku,
        torioroshiKingaku: e.torioroshiKingaku,
        taikiJikan: e.taikiJikanDisp,
        taikiJikanTanka: e.taikiJikanTanka,
        taikiJikanKingaku: e.taikiJikanKingaku,
        futaiGyomuKingaku: e.futaiGyomuKingaku,
        jikanWarimashiKingaku: e.jikanWarimashiKingaku,
        kyoriWarimashiKingaku: e.kyoriWarimashiKingaku,
        warimashiSonotaKingsku: e.warimashiSonotaKingsku,
        seikyuBiko: e.seikyuBiko,
        yoshaKihonUnchin: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaKihonUnchin : null,
        yoshaHiwayPrice: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaHiwayPrice : null,
        yoshaUnchinHokaKingaku: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaUnchinHokaKingaku : null,
        yoshaUnchinHokaHikazei: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaUnchinHokaHikazei : null,
        shiharaiBiko: e.shiharaiBiko
      }

      if (m === 'himozuke') {
        initHaisoMeisai.id = e.id
        initHaisoMeisai.tjmId = e.tjmId
        initHaisoMeisai.tjhId = e.tjhId
        initHaisoMeisai.tjkKinId = e.tjkKinId
        initHaisoMeisai.tjmKinId = e.tjmKinId
        initHaisoMeisai.tjhKinId = e.tjhKinId
        initHaisoMeisai.tjrKihonId = e.tjrKihonId
        initHaisoMeisai.tjrMeisaiId = e.tjrMeisaiId
        initHaisoMeisai.tsmId = e.tsmId
        initHaisoMeisai.tskId = e.tskId
        initHaisoMeisai.tskHinmokuId = e.tskHinmokuId
        initHaisoMeisai.tskMeisaiId = e.tskMeisaiId
        initHaisoMeisai.thkId = e.thkId
        initHaisoMeisai.thmId = e.thmId
        initHaisoMeisai.tshId = e.tshId
        initHaisoMeisai.thkKinId = e.thkKinId
        initHaisoMeisai.thmKinId = e.thmKinId
        initHaisoMeisai.thhId = e.thhId
        initHaisoMeisai.thhKinId = e.thhKinId
        initHaisoMeisai.tjkUpdDate = e.tjkUpdDate
        initHaisoMeisai.tjmUpdDate = e.tjmUpdDate
        initHaisoMeisai.tjhUpdDate = e.tjhUpdDate
        initHaisoMeisai.tjkKinUpdDate = e.tjkKinUpdDate
        initHaisoMeisai.tjmKinUpdDate = e.tjmKinUpdDate
        initHaisoMeisai.tjhKinUpdDate = e.tjhKinUpdDate
        initHaisoMeisai.tjrKihonUpdDate = e.tjrKihonUpdDate
        initHaisoMeisai.tjrMeisaiUpdDate = e.tjrMeisaiUpdDate
        initHaisoMeisai.tsmUpdDate = e.tsmUpdDate
        initHaisoMeisai.tskMeisaiUpdDate = e.tskMeisaiUpdDate
        initHaisoMeisai.tshUpdDate = e.tshUpdDate
        initHaisoMeisai.tskHinmokuUpdDate = e.tskHinmokuUpdDate
        initHaisoMeisai.thkUpdDate = e.thkUpdDate
        initHaisoMeisai.thmUpdDate = e.thmUpdDate
        initHaisoMeisai.thkKinUpdDate = e.thkKinUpdDate
        initHaisoMeisai.thmKinUpdDate = e.thmKinUpdDate
        initHaisoMeisai.thhUpdDate = e.thhUpdDate
        initHaisoMeisai.thhKinUpdDate = e.thhKinUpdDate
        initHaisoMeisai.juchuYmd = e.juchuYmd
        initHaisoMeisai.juchuNo = e.juchuNo
        initHaisoMeisai.sagyoYoteiYmd = e.sagyoYoteiYmd
        initHaisoMeisai.seikyuZumiFlg = e.seikyuZumiFlg ?? false
        initHaisoMeisai.shiharaiZumiFlg = e.shiharaiZumiFlg ?? false
        initHaisoMeisai.motoukeFlg = e.motoukeFlg
        initHaisoMeisai.maninushiNm = e.maninushiNm
        initHaisoMeisai.chumonshoReceiveZumiFlg = e.chumonshoReceiveZumiFlg
        initHaisoMeisai.chumonshoReceiveSbt = e.chumonshoReceiveSbt
        initHaisoMeisai.chumonshoReceiveBiko = e.chumonshoReceiveBiko
        initHaisoMeisai.chumonkakuninshoSendZumiFlg = e.chumonkakuninshoSendZumiFlg
        initHaisoMeisai.hacchushoSendZumiFlg = e.hacchushoSendZumiFlg
        initHaisoMeisai.motoukeNm = e.motoukeNm
        initHaisoMeisai.juchuUkeoiKaiso = e.juchuUkeoiKaiso
        initHaisoMeisai.motoukeRenrakuSbt = e.motoukeRenrakuSbt
        initHaisoMeisai.motoukeRenrakuBiko = e.motoukeRenrakuBiko
        initHaisoMeisai.motoukeRenrakusaki = e.motoukeRenrakusaki
        initHaisoMeisai.chumonshoReceiveZumiFlg = e.chumonshoReceiveZumiFlg
        initHaisoMeisai.chumonshoReceiveSbt = e.chumonshoReceiveSbt
        initHaisoMeisai.chumonshoReceiveBiko = e.chumonshoReceiveBiko
        initHaisoMeisai.motoukeHokokuZumiFlg = e.motoukeHokokuZumiFlg
        initHaisoMeisai.motoukeHokokuYmd = e.motoukeHokokuYmd
        initHaisoMeisai.jitsuUnsoHokokuMemo = e.jitsuUnsoHokokuMemo
        initHaisoMeisai.isHasEasyEditSeikyuKingaku = false
        initHaisoMeisai.isHasEasyEditShiharaiKingaku = false
      }

      this.setInitHaisoMeisai(initHaisoMeisai)
      initHaisoMeisai = undefined
    },
    setInitHaisoMeisai: function (e) {
      if (e.hatsuchiYmd && e.hatsuchiHms && e.chakuchiHms && (e.hatsuchiYmd >= e.chakuchiYmd || !e.chakuchiYmd) && e.hatsuchiHms > e.chakuchiHms) {
        e.chakuchiYmd = filter.dateFormatter(dayjs(e.hatsuchiYmd).add(1, 'd'))
      }
      this.recHaisoMeisai = Object.assign({}, e)
    },
    onRowDoubleClick: function (e, f) {
      if (f.item.delFlg) { return }
      this.onMeisaiEditOpenButtonClick(f.item)
    },
    onMeisaiNewButtonClick: function () {
      this.initHaisoMeisai()
    },
    onMeisaiEditMoveUpButtonClick: function (item) {
      const index = this.viewsData.vwHaisoMeisai.indexOf(item)
      if (index === 0 || index === -1) { return }
      this.viewsData.vwHaisoMeisai.splice(
        index - 1,
        2,
        this.viewsData.vwHaisoMeisai[index],
        this.viewsData.vwHaisoMeisai[index - 1])
      if (this.haisoMeisaiEditIndex === index) {
        this.haisoMeisaiEditIndex = index - 1
        this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index - 1].meisaiOrder
      } else if (this.haisoMeisaiEditIndex === index - 1) {
        this.haisoMeisaiEditIndex = index
        this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index].meisaiOrder
      }
      const tempJuchuMeisai1 = this.viewsData.vwHaisoMeisai[index]
      const tempJuchuMeisai2 = this.viewsData.vwHaisoMeisai[index - 1]
      const tempmeisaiOrder1 = this.viewsData.vwHaisoMeisai[index - 1].meisaiOrder
      this.viewsData.vwHaisoMeisai[index - 1] = tempJuchuMeisai2
      this.viewsData.vwHaisoMeisai[index - 1].meisaiOrder = tempJuchuMeisai1.meisaiOrder
      this.viewsData.vwHaisoMeisai[index] = tempJuchuMeisai1
      this.viewsData.vwHaisoMeisai[index].meisaiOrder = tempmeisaiOrder1
    },
    onMeisaiEditMoveDownButtonClick: function (item) {
      const index = this.viewsData.vwHaisoMeisai.indexOf(item)
      if (index === this.viewsData.vwHaisoMeisai.length - 1 || index === -1) { return }
      this.viewsData.vwHaisoMeisai.splice(
        index,
        2,
        this.viewsData.vwHaisoMeisai[index + 1],
        this.viewsData.vwHaisoMeisai[index])
      if (this.haisoMeisaiEditIndex === index) {
        this.haisoMeisaiEditIndex = index + 1
        this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index + 1].meisaiOrder
      } else if (this.haisoMeisaiEditIndex === index + 1) {
        this.haisoMeisaiEditIndex = index
        this.recHaisoMeisai.meisaiOrder = this.viewsData.vwHaisoMeisai[index].meisaiOrder
      }
      const tempJuchuMeisai1 = this.viewsData.vwHaisoMeisai[index]
      const tempJuchuMeisai2 = this.viewsData.vwHaisoMeisai[index + 1]
      const tempmeisaiOrder1 = this.viewsData.vwHaisoMeisai[index].meisaiOrder
      this.viewsData.vwHaisoMeisai[index] = tempJuchuMeisai1
      this.viewsData.vwHaisoMeisai[index].meisaiOrder = tempJuchuMeisai2.meisaiOrder
      this.viewsData.vwHaisoMeisai[index + 1] = tempJuchuMeisai2
      this.viewsData.vwHaisoMeisai[index + 1].meisaiOrder = tempmeisaiOrder1
    },
    onMeisaiEditOpenButtonClick: function (item) {
      this.initializeMode = true
      this.haisoMeisaiEditIndex = this.viewsData.vwHaisoMeisai.indexOf(item)
      this.viewsData.vwHaisoMeisai.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex].selectRow = true
      this.recHaisoMeisai = Object.assign({}, item)
      // this.tempHaisoMeisai = this.recHaisoMeisai
      // this.$refs.seikyuYoteiYmd.onCalendarInput(this.recHaisoMeisai.seikyuYoteiYmd)

      this.expandKeiyuchi = Boolean(this.recHaisoMeisai.keiyuchiId2 || this.recHaisoMeisai.keiyuchiBiko2 || this.recHaisoMeisai.keiyuchiId3 || this.recHaisoMeisai.keiyuchiBiko3 || this.recHaisoMeisai.keiyuchiId4 || this.recHaisoMeisai.keiyuchiBiko4 || this.recHaisoMeisai.keiyuchiId5 || this.recHaisoMeisai.keiyuchiBiko5)

      if (this.recHaisoMeisai.taikiJikan !== null && this.recHaisoMeisai.taikiJikan !== undefined) {
        this.recHaisoMeisai.taikiJikan = this.calcTime(String(this.recHaisoMeisai.taikiJikan))
      }

      if (this.recHaisoMeisai.yoteiSagyoJikan !== null && this.recHaisoMeisai.yoteiSagyoJikan !== undefined) {
        this.recHaisoMeisai.yoteiSagyoJikan = this.calcTime(String(this.recHaisoMeisai.yoteiSagyoJikan))
      }

      if (this.recHaisoMeisai.warimashiTaishoJikan !== null && this.recHaisoMeisai.warimashiTaishoJikan !== undefined) {
        this.recHaisoMeisai.warimashiTaishoJikan = this.calcTime(String(this.recHaisoMeisai.warimashiTaishoJikan))
      }

      if (![undefined, null, ''].includes(this.recHaisoMeisai.jitsuUnsoTaiseiKanriList)) {
        this.recHaisoMeisai.jitsuUnsoTaiseiKanriList.map((elem) => {
          elem.tsumikomiYmd = filter.dateFormatter(elem.tsumikomiYmd)
          return elem
        })
        const dispRow = this.recHaisoMeisai.jitsuUnsoTaiseiKanriList.filter((elem) => {
          return elem.delFlg === false
        })

        this.recHaisoMeisai.dispJitsuUnsoTaiseiKanriList = Object.assign([], dispRow)
      }
    },
    onMeisaiDeleteButtonClick: function (item) {
      const index = this.viewsData.vwHaisoMeisai.indexOf(item)
      var deleteRowInfo = Object.assign({}, item)
      deleteRowInfo.delFlg = !deleteRowInfo.delFlg
      Object.assign(this.viewsData.vwHaisoMeisai[index], deleteRowInfo)
      this.viewsData.vwHaisoMeisai.splice()
    },
    onMeisaiDeleteFooterButtonClick: function () {
      this.onMeisaiDeleteButtonClick(this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex])
    },
    onMeisaiCopyButtonClick: function (item) {
      this.recHaisoMeisai = item
      this.onMeisaiCopyFooterButtonClick()
      this.onMeisaiSaveButtonClick(false)
    },
    onMeisaiCopyFooterButtonClick: function () {
      this.viewsData.vwHaisoMeisai.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.tempHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
      this.tempHaisoMeisai.id = -1
      this.tempHaisoMeisai.tjmId = -1
      this.tempHaisoMeisai.tjhId = -1
      this.tempHaisoMeisai.tjkKinId = -1
      this.tempHaisoMeisai.tjmKinId = -1
      this.tempHaisoMeisai.tjhKinId = -1
      this.tempHaisoMeisai.tjrKihonId = -1
      this.tempHaisoMeisai.tjrMeisaiId = -1
      this.tempHaisoMeisai.tsmId = -1
      this.tempHaisoMeisai.tskMeisaiId = -1
      this.tempHaisoMeisai.tshId = -1
      this.tempHaisoMeisai.tskHinmokuId = -1
      this.tempHaisoMeisai.thkId = -1
      this.tempHaisoMeisai.thmId = -1
      this.tempHaisoMeisai.thkKinId = -1
      this.tempHaisoMeisai.thmKinId = -1
      this.tempHaisoMeisai.thhId = -1
      this.tempHaisoMeisai.thhKinId = -1
      this.tempHaisoMeisai.juchuNo = null
      this.tempHaisoMeisai.meisaiOrder = null
      this.tempHaisoMeisai.seikyuZumiFlg = false
      this.tempHaisoMeisai.shiharaiZumiFlg = false
      this.tempHaisoMeisai.jitsuUnsoTaiseiKanriList = []
      this.tempHaisoMeisai.dispJitsuUnsoTaiseiKanriList = []
      this.recHaisoMeisai = this.tempHaisoMeisai
      this.haisoMeisaiEditIndex = -1
    },
    onMeisaiSaveButtonClick: function (message) {
      if (!this.haisoMeisaiValidate()) { return }
      // this.tempHaisoMeisai = this.recHaisoMeisai
      // 更新時
      if (this.recHaisoMeisai.dispJitsuUnsoTaiseiKanriList.length > 0) {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.convertKanriboResult(this.recHaisoMeisai)
      }
      if (this.recHaisoMeisai.meisaiOrder) {
        Object.assign(this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex], this.recHaisoMeisai)
      } else {
        // 新規追加時
        // this.recHaisoMeisai.id = -1
        this.recHaisoMeisai.delFlg = false
        this.recHaisoMeisai.selectRow = true
        const max = Math.max.apply(null, this.filteredHaisoMeisaiListRows.map(function (o) {
          return [undefined, null, ''].includes(o.meisaiOrder) ? 0 : o.meisaiOrder
        }))
        const meisaiOrder = 1 + (max !== -Infinity ? max : 0)

        this.recHaisoMeisai.meisaiOrder = meisaiOrder

        if (this.viewsData.vwHaisoMeisai.length > 0) {
          this.viewsData.vwHaisoMeisai.push(this.recHaisoMeisai)
        } else {
          this.viewsData.vwHaisoMeisai = [this.recHaisoMeisai]
        }
        this.haisoMeisaiEditIndex = this.viewsData.vwHaisoMeisai.indexOf(this.recHaisoMeisai)
      }

      if (this.recHaisoMeisai.taikiJikan !== null && this.recHaisoMeisai.taikiJikan !== undefined) {
        this.recHaisoMeisai.taikiJikan = this.calcTime(String(this.recHaisoMeisai.taikiJikan))
      }

      this.viewsData.vwHaisoMeisai.splice()

      if (message) modals.showToastMessage('PRMI0001', null, 700, null, 'info', ['表示されている配送明細', '「保存」ボタンより登録処理'])
    },
    haisoMeisaiValidate: function () {
      var msg
      if (!this.recHaisoMeisai.juchuEigyoshoId) {
        this.$refs.juchuEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.recHaisoMeisai.tokuisakiId) {
        this.$refs.tokuisakiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.recHaisoMeisai.seikyuYoteiYmd) {
        this.$refs.seikyuYoteiYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (this.recHaisoMeisai.hatsuchiYmd && this.recHaisoMeisai.chakuchiYmd) {
        msg = validators.compareDate(this.recHaisoMeisai.hatsuchiYmd, this.recHaisoMeisai.chakuchiYmd)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.recHaisoMeisai.hatsuchiHms && this.recHaisoMeisai.chakuchiHms && !this.recHaisoMeisai.hatsuchiYmd && !this.recHaisoMeisai.chakuchiYmd) {
        msg = validators.compareTime(this.recHaisoMeisai.hatsuchiHms, this.recHaisoMeisai.chakuchiHms)
        if (msg !== undefined) {
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.recHaisoMeisai.hatsuchiYmd && this.recHaisoMeisai.hatsuchiHms && this.recHaisoMeisai.chakuchiYmd && this.recHaisoMeisai.chakuchiHms) {
        msg = validators.compareDateTime(this.recHaisoMeisai.hatsuchiYmd, this.recHaisoMeisai.hatsuchiHms, this.recHaisoMeisai.chakuchiYmd, this.recHaisoMeisai.chakuchiHms)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id, keikakujissekikey: self.keikakujissekikey, trJuchuKihonId: self.trJuchuKihonId }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.viewsData = self.cloneData.viewsData
            self.recHaisoMeisai = self.cloneData.recHaisoMeisai
            self.recNenryo = self.cloneData.recNenryo
            self.recTsukoryo = self.cloneData.recTsukoryo
            self.nenryoCount = self.cloneData.nenryoCount
            self.tsukoryoCount = self.cloneData.tsukoryoCount
            self.kakuninzumiMode = Boolean(self.cloneData.viewsData.vwSagyoJisseki.jissekiKakuninZumiFlg)
            self.seikyuZumiMode = Boolean(
              self.cloneData.viewsData.vwHaisoMeisai.find((t) => {
                return t.seikyuZumiFlg === true
              })
            )
            self.shiharaiZumiMode = Boolean(
              self.cloneData.viewsData.vwHaisoMeisai.find((t) => {
                return t.shiharaiZumiFlg === true
              })
            )
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      this.isHaisoMeisaiRequired = false
      this.$nextTick(function () {
        this.deleteAction()
      })
    },
    deleteAction: function (e) {
      this.tempViewsData = Object.assign({}, this.viewsData)
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            this.deleteMode = 1
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.kosokuJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.kosokuJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.kosokuJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.kadouJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.kadouJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.kadouJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.zangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.zangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.zangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJomuin.kyukeiJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJomuin.kyukeiJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.kosokuJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.kosokuJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.kosokuJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.kadouJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.kadouJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.kadouJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.zangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.zangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.zangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan)
            }
            if (self.cloneData.viewsData.vwKintaiJissekiJoshu.kyukeiJikan) {
              self.cloneData.viewsData.vwKintaiJissekiJoshu.kyukeiJikan = filter.timeToMinFormatter(self.cloneData.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)
            }
            if (self.cloneData.viewsData.vwHaisoMeisai.length !== 0) {
              self.cloneData.viewsData.vwHaisoMeisai.forEach(p => {
                if (p.taikiJikan) {
                  p.taikiJikan = filter.timeToMinFormatter(p.taikiJikan)
                }
                if (p.yoteiSagyoJikan) {
                  p.yoteiSagyoJikan = filter.timeToMinFormatter(p.yoteiSagyoJikan)
                }
                if (p.warimashiTaishoJikan) {
                  p.warimashiTaishoJikan = filter.timeToMinFormatter(p.warimashiTaishoJikan)
                }
              })
            }
            self.viewsData = self.cloneData.viewsData
            self.HttpClient.post('/api/v1/D2PRMD0020/JuchuWithJissekiDelete', self.viewsData).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id, keikakujissekikey: self.keikakujissekikey, trJuchuKihonId: self.trJuchuKihonId }
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.viewsData = this.tempViewsData
            this.convertToDispType()
            this.deleteMode = 0
            this.isHaisoMeisaiRequired = true
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    onNewButtonClick: function (e) {
      this.initBindVariables()
      // キー情報初期化
      this.id = 0
      this.keikakujissekikey = 0
    },
    onCopyButtonClick: function (e) {
      const self = this
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        self.Effects.loadStart()
        const inputData = Object.assign({}, self.viewsData)
        inputData.vwUnkoJisseki.id = -1
        inputData.vwUnkoJisseki.unkoJissekiNo = null
        inputData.vwSagyoJisseki.id = -1
        inputData.vwKintaiJissekiJomuin.id = -1
        inputData.vwKintaiJissekiJoshu.id = -1
        /*
        const inputHaisoData = Object.assign({}, this.recHaisoMeisai)
        inputHaisoData.id = -1
        inputHaisoData.tjmId = null
        inputHaisoData.tjhId = null
        inputHaisoData.tjkKinId = null
        inputHaisoData.tjmKinId = null
        inputHaisoData.tjhKinId = null
        inputHaisoData.tjrKihonId = null
        inputHaisoData.tjrMeisaiId = null
        inputHaisoData.tsmId = null
        inputHaisoData.tskMeisaiId = null
        inputHaisoData.tshId = null
        inputHaisoData.tskHinmokuId = null
        inputHaisoData.thkId = null
        inputHaisoData.thmId = null
        inputHaisoData.thkKinId = null
        inputHaisoData.thmKinId = null
        inputHaisoData.juchuNo = null
        inputHaisoData.meisaiOrder = null
        this.recHaisoMeisai = Object.assign({}, inputHaisoData)
        this.recNenryo.id = -1
        this.recNenryo.sharyoKeihiNo = null
        this.recTsukoryo.id = -1
        this.recTsukoryo.sharyoKeihiNo = null
        */
        if (inputData.vwHaisoMeisai.length > 0) {
          inputData.vwHaisoMeisai.forEach(p => {
            p.id = -1
            p.tjmId = -1
            p.tjhId = -1
            p.tjkKinId = -1
            p.tjmKinId = -1
            p.tjhKinId = -1
            p.tjrKihonId = -1
            p.tjrMeisaiId = -1
            p.tsmId = -1
            p.tskMeisaiId = -1
            p.tshId = -1
            p.tskHinmokuId = -1
            p.thkId = -1
            p.thmId = -1
            p.thkKinId = -1
            p.thmKinId = -1
            p.thhId = -1
            p.thhKinId = -1
            p.juchuNo = null
            // p.meisaiOrder = null
            p.seikyuZumiFlg = false
            p.shiharaiZumiFlg = false
            p.jitsuUnsoTaiseiKanriList = []
            p.dispJitsuUnsoTaiseiKanriList = []
          })
        }
        self.viewsData = Object.assign({}, inputData)
        self.initHaisoMeisai()
        self.initNenryo()
        self.initTsukoryo()

        self.kakuninzumiMode = false

        self.id = 0
        self.modeOfEdit = 0
        self.copyMode = true
        self.Effects.loadComplete()
      })
    },
    onSaveButtonClick: function (e) {
      if (![undefined, null, ''].includes(this.recHaisoMeisai.tokuisakiId)) {
        this.onJuchuEditSaveButtonClick(false)
      }
      this.registerAction()
    },
    registerAction: function (e) {
      this.tempViewsData = Object.assign({}, this.viewsData)
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            if (data.isValid) {
              const inputData = {}
              inputData.vwUnkoJisseki = data.payload.vwUnkoJisseki
              self.id = inputData.vwUnkoJisseki.id
              self.copyMode = false
              self.fetchData()
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return [self.id, self.keikakujissekikey]
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.$set(self, 'id', id[0])
            self.$set(self, 'modeOfEdit', 2)
            // self.id = id[0]
            // self.modeOfEdit = 2
            self.transition(1, { id: id, keikakujissekikey: self.keikakujissekikey }, self.initialize)
            console.log('★transition')
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id, keikakujissekikey: self.keikakujissekikey }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            self.viewsData = self.tempViewsData
            self.convertToDispType()
            self.isHaisoMeisaiRequired = true
            resolve()
          })
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      // 運行実績の出庫帰庫と勤怠の出庫帰庫を分けて登録する場合は、sharyoJininTimeSeparateModeを'1'に設定する。
      this.viewsData.sharyoJininTimeSeparateMode = 1
      const f = this.HttpClient.post('/api/v1/D2PRMD0020/JuchuWithJissekiCreate', this.viewsData)
      return f
    },
    registerValidate: function () {
      var msg
      if (!this.compareDateTimeJomuin()) return false
      if (!this.compareDateTimeJoshu()) return false
      if (!this.compareDateTimeOperation()) return false
      // オドメータ妥当性チェック
      this.$refs.hatsuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.chakuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](undefined)
      if (this.viewsData.vwUnkoJisseki.hatsuchiOdoMater && this.viewsData.vwUnkoJisseki.chakuchiOdoMater) {
        msg = validators.compareNumerical(parseFloat(this.viewsData.vwUnkoJisseki.hatsuchiOdoMater), parseFloat(this.viewsData.vwUnkoJisseki.chakuchiOdoMater))
        if (msg !== undefined) {
          this.$refs.hatsuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiOdoMater[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    },
    deleteValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.widthOfLineHeader = [0, 0, 0]
      // 基準日初期値設定
      this.baseYmd = date.getCurrentDate()
      // this.modeKengen = 0
      this.deleteMode = 0
      // this.modeOfEdit = 0
      this.kakuninzumiMode = false
      this.seikyuZumiMode = false
      this.shiharaiZumiMode = false
      this.haishaEigyoshoCd = this.usersEigyosho
      this.jishaSharyoSbt = null
      this.yoshaSharyoSbt = null
      this.tempViewsData = {}
      this.lastUnkoJissekiInfo = {}
      this.jiEigyoshoId = this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id : null
      const initData = {
        vwUnkoJisseki: {
          unkoYmd: filter.dateFormatter(new Date()),
          haishaKbn: '03',
          sharyoId: null,
          hacchusakiShaban: null,
          hacchusakiShashuSbt: null,
          hatsuchiOdoMater: '',
          chakuchiOdoMater: '',
          sokoKyori: 0,
          jisshaKyori: 0,
          jissekiShukkoYmd: '',
          jissekiShukkoHms: '',
          jissekiKikoYmd: '',
          jissekiKikoHms: '',
          hacchusakiId: null,
          hacchusakiJomuinId: null
        },
        vwSagyoJisseki: {
          jissekiKakuninZumiFlg: false,
          torokuTantoshaId: this.usersId,
          eigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id : null
        },
        vwKintaiJissekiJomuin: {
          jininId: '',
          shukkinYmd: null,
          shukkinHms: null,
          taikinYmd: null,
          taikinHms: null,
          kosokuJikan: null,
          kyukeiJikan: null,
          kadouJikan: null,
          kinmuTeateKingaku1: null,
          kinmuTeateKingaku2: null,
          kinmuTeateKingaku3: null,
          kinmuTeateKingaku4: null,
          kinmuTeateKingaku5: null
        },
        vwKintaiJissekiJoshu: {
          jininId: '',
          shukkinYmd: null,
          shukkinHms: null,
          taikinYmd: null,
          taikinHms: null,
          kosokuJikan: null,
          kyukeiJikan: null,
          kadouJikan: null,
          kinmuTeateKingaku1: null,
          kinmuTeateKingaku2: null,
          kinmuTeateKingaku3: null,
          kinmuTeateKingaku4: null,
          kinmuTeateKingaku5: null
        },
        vwHaisoMeisai: [],
        trSagyoKeikakuJininList: [],
        trSagyoKeikakuMeisaiList: [],
        vwSharyoKeihiNenryohi: [],
        vwSharyoKeihiTsukoryo: []
      }
      this.viewsData = Object.assign({}, initData)
      this.initHaisoMeisai()
      // this.$refs.seikyuYoteiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.recNenryo = {}
      this.recTsukoryo = {}
      this.recNenryo.torihikisakiId = null
      this.registerMode = 0
      this.isJishaHaishaMode = true
      this.isJiEigyoshoMode = true
      this.isHokaEigyoshoMode = false
      this.isHaisoMeisaiRequired = true
      this.expandKeiyuchi = false
      // 権限制御
      this.isReadOnlyCommon = false
      this.isReadOnlyJisha = false
      this.isReadOnlyYosha = false
    },
    initHaisoMeisai: function () {
      this.clearInvalidMessage(this.$refs)
      this.viewsData.vwHaisoMeisai.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.recHaisoMeisai = {}
      this.tempHaisoMeisai = {}
      this.recTokuisakiInfo = {}
      this.isHaisoMeisaiRequired = true
      this.expandKeiyuchi = false
      this.haisoMeisaiEditIndex = -1
      this.$set(this,
        'recHaisoMeisai',
        {
          unchinKakuteiFlg: false,
          seikyuTomeFlg: false,
          juchuEigyoshoId: this.viewsData.vwUnkoJisseki.haishaKbn === '02' ? this.viewsData.vwSagyoJisseki.eigyoshoId : indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id,
          tokuisakiId: null,
          teikeiKihonNo: null,
          mstHinmeiId: null,
          hatsuchiId: null,
          chakuchiId: null,
          keiyuchiId1: null,
          juchuSuryo: null,
          juchuJuryo: null,
          tanka: null,
          unchinKeisanKbn: '03',
          seikyuShashuSbt: this.viewsData.vwUnkoJisseki.haishaKbn === '02' ? this.jishaSharyoSbt : this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt,
          nenryoSurcharge: null,
          tsumikomiKingaku: null,
          torioroshiKingaku: null,
          taikiJikan: null,
          taikiJikanTanka: null,
          taikiJikanKingaku: null,
          futaiGyomuKingaku: null,
          motoukeFlg: true,
          jitsuUnsoTaiseiKanriList: [],
          dispJitsuUnsoTaiseiKanriList: [],
          jikanWarimashiKingaku: null,
          kyoriWarimashiKingaku: null,
          seikyuYoteiYmd: this.viewsData.vwUnkoJisseki.unkoYmd,
          shiharaiYoteiYmd: this.viewsData.vwUnkoJisseki.unkoYmd
        })
      this.recHaisoMeisai.juchuEigyoshoCd = [undefined, null].includes(this.recHaisoMeisai.juchuEigyoshoId) ? null : indexeddb.getRecord(this.eigyoshoList, this.recHaisoMeisai.juchuEigyoshoId).eigyoshoCd
      // this.$refs.seikyuYoteiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.tempHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
      this.selectPopUpCondtion = {
        juchuEigyoshoId: this.recHaisoMeisai.juchuEigyoshoId,
        tokuisakiId: null,
        hatsuchiId: null,
        chakuchiId: null,
        mstHinmeiId: null
      }
    },
    initNenryo: function () {
      this.clearInvalidMessage(this.$refs)
      this.viewsData.vwSharyoKeihiNenryohi.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.recNenryo = {}
      this.tempNenryo = {}
      this.recNenryo.torihikisakiId = null
      this.nenryoEditIndex = -1
      this.tempNenryo = Object.assign({}, this.recNenryo)
    },
    initTsukoryo: function () {
      this.clearInvalidMessage(this.$refs)
      this.viewsData.vwSharyoKeihiTsukoryo.map((elem) => {
        elem.selectRow = false
        return elem
      })
      this.recTsukoryo = {}
      this.tempTsukoryo = {}
      this.tsukoryoEditIndex = -1
      this.tempTsukoryo = Object.assign({}, this.recTsukoryo)
    },
    // パラメタ取得用
    setFromParameters: function (parms) {
      return new Promise((resolve) => {
        var args
        if (typeof (parms) === 'string') {
          args = parms.split('/')
        } else if (Array.isArray(parms)) {
          args = parms
        } else if (typeof (parms) === 'number') {
          this.id = parms
          return
        } else {
          console.warn('★undefined way to parm...')
          return
        }
        if (args.length === 0) {
          this.id = 0
          this.keikakujissekikey = '0'
          this.trJuchuKihonId = 0
        } else if (args.length === 1) {
          this.id = args[0]
          if (this.id === '0') {
            this.id = 0
          }
          this.keikakujissekikey = '0'
          this.trJuchuKihonId = 0
        } else if (args.length === 2) {
          this.id = args[0]
          if (this.id === '0') {
            this.id = 0
          }
          this.keikakujissekikey = args[1]
          this.trJuchuKihonId = 0
        } else if (args.length >= 3) {
          this.id = args[0]
          if (this.id === '0') {
            this.id = 0
          }
          this.keikakujissekikey = args[1]
          this.trJuchuKihonId = args[2]
        }
        console.log('ids', this.id, this.keikakujissekikey, this.trJuchuKihonId)
        resolve()
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // DB処理用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDBType: function () {
      const tmpData = Object.assign({}, this.viewsData)
      if (tmpData.vwKintaiJissekiJomuin.kosokuJikan) {
        tmpData.vwKintaiJissekiJomuin.kosokuJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.kosokuJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.kadouJikan) {
        tmpData.vwKintaiJissekiJomuin.kadouJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.kadouJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.zangyoJikan) {
        tmpData.vwKintaiJissekiJomuin.zangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.zangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.shinyaJikan) {
        tmpData.vwKintaiJissekiJomuin.shinyaJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.shinyaJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
        tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.shinyaZangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJomuin.kyukeiJikan) {
        tmpData.vwKintaiJissekiJomuin.kyukeiJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJomuin.kyukeiJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.kosokuJikan) {
        tmpData.vwKintaiJissekiJoshu.kosokuJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.kosokuJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.kadouJikan) {
        tmpData.vwKintaiJissekiJoshu.kadouJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.kadouJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.zangyoJikan) {
        tmpData.vwKintaiJissekiJoshu.zangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.zangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.shinyaJikan) {
        tmpData.vwKintaiJissekiJoshu.shinyaJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.shinyaJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
        tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.shinyaZangyoJikan)
      }
      if (tmpData.vwKintaiJissekiJoshu.kyukeiJikan) {
        tmpData.vwKintaiJissekiJoshu.kyukeiJikan = filter.timeToMinFormatter(tmpData.vwKintaiJissekiJoshu.kyukeiJikan)
      }
      if (tmpData.vwHaisoMeisai.length !== 0) {
        tmpData.vwHaisoMeisai.forEach(p => {
          if (p.taikiJikan) {
            p.taikiJikan = filter.timeToMinFormatter(p.taikiJikan)
          }
          if (p.yoteiSagyoJikan) {
            p.yoteiSagyoJikan = filter.timeToMinFormatter(p.yoteiSagyoJikan)
          }
          if (p.warimashiTaishoJikan) {
            p.warimashiTaishoJikan = filter.timeToMinFormatter(p.warimashiTaishoJikan)
          }
          if (p.dispJitsuUnsoTaiseiKanriList.length > 0) {
            this.$refs.dispJitsuUnsoTaiseiKanriListComponent.convertKanriboResult(p)
          }
        })
      }
      this.viewsData = Object.assign({}, tmpData)
    },
    // ----------------------------------------------------------------------------------------------------
    // 受注ダイアログ
    // ----------------------------------------------------------------------------------------------------
    onJuchuEditNewButtonClick: function (item) {
      this.initHaisoMeisai()
    },
    onJuchuEditDeleteButtonClick: function () {
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }

        this.recHaisoMeisai.delFlg = true
        Object.assign(this.viewsData.vwHaisoMeisai[this.haisoMeisaiEditIndex], this.recHaisoMeisai)
        self.$nextTick(() => {
          this.calcWidthLineHeader()
        })
      })
    },
    onJuchuEditSaveButtonClick: function (message) {
      // 受注登録処理
      const targetMeisai = this.viewsData.vwHaisoMeisai.find(({ selectRow }) => selectRow === true)
      if (targetMeisai) {
        if (targetMeisai !== this.recHaisoMeisai) {
          if (!this.haisoMeisaiValidate()) { return }
          this.onMeisaiSaveButtonClick(message)
        }
      } else {
        const targetHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
        const initHaisoMeisai = {
          unchinKakuteiFlg: false,
          seikyuTomeFlg: false,
          juchuEigyoshoId: this.viewsData.vwUnkoJisseki.haishaKbn === '02' ? this.viewsData.vwSagyoJisseki.eigyoshoId : indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id,
          tokuisakiId: null,
          mstHinmeiId: null,
          hatsuchiId: null,
          chakuchiId: null,
          keiyuchiId1: null,
          keiyuchiId2: null,
          keiyuchiId3: null,
          keiyuchiId4: null,
          keiyuchiId5: null,
          seikyuYoteiYmd: filter.dateFormatter(new Date()),
          juchuSuryo: null,
          juchuJuryo: null,
          tanka: null,
          unchinKeisanKbn: null,
          seikyuShashuSbt: null,
          jikanWarimashiKingaku: null,
          kyoriWarimashiKingaku: null
        }
        const initHaisoMeisaiJson = JSON.stringify(Object.entries(initHaisoMeisai).sort())
        const targetHaisoMeisaiJson = JSON.stringify(Object.entries(targetHaisoMeisai).sort())
        if (initHaisoMeisaiJson !== targetHaisoMeisaiJson) {
          if (!this.haisoMeisaiValidate()) { return }
          this.onMeisaiSaveButtonClick(message)
        }
      }

      // 新規モードに切り替え
      this.initHaisoMeisai()
    },
    // ----------------------------------------------------------------------------------------------------
    // 画面表示用フォーマット変換
    // ----------------------------------------------------------------------------------------------------
    convertToDispType: function () {
      return new Promise(resolve => {
        const tmpData = Object.assign({}, this.viewsData)
        if (tmpData.vwUnkoJisseki.unkoYmd) {
          tmpData.vwUnkoJisseki.unkoYmd = filter.dateFormatter(tmpData.vwUnkoJisseki.unkoYmd)
        }
        if (tmpData.vwKintaiJissekiJomuin.shukkinYmd) {
          tmpData.vwKintaiJissekiJomuin.shukkinYmd = filter.dateFormatter(tmpData.vwKintaiJissekiJomuin.shukkinYmd)
        }
        if (tmpData.vwKintaiJissekiJomuin.shukkinHms) {
          tmpData.vwKintaiJissekiJomuin.shukkinHms = complements.parseTime(tmpData.vwKintaiJissekiJomuin.shukkinHms, false).substr(0, 5)
        }
        if (tmpData.vwKintaiJissekiJomuin.taikinYmd) {
          tmpData.vwKintaiJissekiJomuin.taikinYmd = filter.dateFormatter(tmpData.vwKintaiJissekiJomuin.taikinYmd)
        }
        if (tmpData.vwKintaiJissekiJomuin.taikinHms) {
          tmpData.vwKintaiJissekiJomuin.taikinHms = complements.parseTime(tmpData.vwKintaiJissekiJomuin.taikinHms, false).substr(0, 5)
        }
        if (tmpData.vwKintaiJissekiJomuin.kosokuJikan) {
          tmpData.vwKintaiJissekiJomuin.kosokuJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.kosokuJikan)
        }
        if (tmpData.vwKintaiJissekiJomuin.kyukeiJikan) {
          tmpData.vwKintaiJissekiJomuin.kyukeiJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.kyukeiJikan)
        }
        if (tmpData.vwKintaiJissekiJomuin.kadouJikan) {
          tmpData.vwKintaiJissekiJomuin.kadouJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJomuin.kadouJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.shukkinYmd) {
          tmpData.vwKintaiJissekiJoshu.shukkinYmd = filter.dateFormatter(tmpData.vwKintaiJissekiJoshu.shukkinYmd)
        }
        if (tmpData.vwKintaiJissekiJoshu.shukkinHms) {
          tmpData.vwKintaiJissekiJoshu.shukkinHms = complements.parseTime(tmpData.vwKintaiJissekiJoshu.shukkinHms, false).substr(0, 5)
        }
        if (tmpData.vwKintaiJissekiJoshu.taikinYmd) {
          tmpData.vwKintaiJissekiJoshu.taikinYmd = filter.dateFormatter(tmpData.vwKintaiJissekiJoshu.taikinYmd)
        }
        if (tmpData.vwKintaiJissekiJoshu.taikinHms) {
          tmpData.vwKintaiJissekiJoshu.taikinHms = complements.parseTime(tmpData.vwKintaiJissekiJoshu.taikinHms, false).substr(0, 5)
        }
        if (tmpData.vwKintaiJissekiJoshu.kosokuJikan) {
          tmpData.vwKintaiJissekiJoshu.kosokuJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.kosokuJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.kyukeiJikan) {
          tmpData.vwKintaiJissekiJoshu.kyukeiJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.kyukeiJikan)
        }
        if (tmpData.vwKintaiJissekiJoshu.kadouJikan) {
          tmpData.vwKintaiJissekiJoshu.kadouJikan = filter.minToIntervalTimeFormatter(tmpData.vwKintaiJissekiJoshu.kadouJikan)
        }
        if (tmpData.vwUnkoJisseki.jissekiShukkoYmd) {
          tmpData.vwUnkoJisseki.jissekiShukkoYmd = filter.dateFormatter(tmpData.vwUnkoJisseki.jissekiShukkoYmd)
        }
        if (tmpData.vwUnkoJisseki.jissekiShukkoHms) {
          tmpData.vwUnkoJisseki.jissekiShukkoHms = complements.parseTime(tmpData.vwUnkoJisseki.jissekiShukkoHms, false).substr(0, 5)
        }
        if (tmpData.vwUnkoJisseki.jissekiKikoYmd) {
          tmpData.vwUnkoJisseki.jissekiKikoYmd = filter.dateFormatter(tmpData.vwUnkoJisseki.jissekiKikoYmd)
        }
        if (tmpData.vwUnkoJisseki.jissekiKikoHms) {
          tmpData.vwUnkoJisseki.jissekiKikoHms = complements.parseTime(tmpData.vwUnkoJisseki.jissekiKikoHms, false).substr(0, 5)
        }
        if (tmpData.vwHaisoMeisai.length > 0) {
          tmpData.vwHaisoMeisai.forEach(p => {
            if (p.hatsuchiYmd) {
              p.hatsuchiYmd = filter.dateFormatter(p.hatsuchiYmd)
            }
            if (p.hatsuchiHms) {
              p.hatsuchiHms = complements.parseTime(p.hatsuchiHms, false).substr(0, 5)
            }
            if (p.chakuchiYmd) {
              p.chakuchiYmd = filter.dateFormatter(p.chakuchiYmd)
            }
            if (p.chakuchiHms) {
              p.chakuchiHms = complements.parseTime(p.chakuchiHms, false).substr(0, 5)
            }
            if (p.seikyuYoteiYmd) {
              p.seikyuYoteiYmd = filter.dateFormatter(p.seikyuYoteiYmd)
            }
            if (p.yoteiSagyoJikan) {
              p.yoteiSagyoJikan = filter.minToIntervalTimeFormatter(p.yoteiSagyoJikan)
            }
            if (p.taikiJikan) {
              p.taikiJikan = filter.minToIntervalTimeFormatter(p.taikiJikan)
            }
            if (p.warimashiTaishoJikan) {
              p.warimashiTaishoJikan = filter.minToIntervalTimeFormatter(p.warimashiTaishoJikan)
            }
            if (p.shiharaiYoteiYmd) {
              p.shiharaiYoteiYmd = filter.dateFormatter(p.shiharaiYoteiYmd)
            }
            if (p.motoukeHokokuYmd) {
              p.motoukeHokokuYmd = filter.dateFormatter(p.motoukeHokokuYmd)
            }
            p.selectRow = false
          })
        }
        if (tmpData.vwSharyoKeihiNenryohi.length > 0) {
          tmpData.vwSharyoKeihiNenryohi.forEach(p => {
            p.selectRow = false
          })
        }
        if (tmpData.vwSharyoKeihiTsukoryo.length > 0) {
          tmpData.vwSharyoKeihiTsukoryo.forEach(p => {
            p.selectRow = false
          })
        }
        this.viewsData = Object.assign({}, tmpData)
        this.onChangeHaishaKbn()
        resolve()
      })
    },
    onChangeHaishaKbn: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '02') {
        this.isJishaHaishaMode = true
        this.isJiEigyoshoMode = true
        this.isHokaEigyoshoMode = false
        // this.haishaEigyoshoCd = this.usersEigyosho
        if (!this.recHaisoMeisai.meisaiOrder) {
          this.recHaisoMeisai.juchuEigyoshoId = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id
        }
      } else if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.isJishaHaishaMode = false
        this.isJiEigyoshoMode = false
        this.isHokaEigyoshoMode = false
        this.haishaEigyoshoCd = this.usersEigyosho
        if (!this.recHaisoMeisai.meisaiOrder) {
          this.recHaisoMeisai.juchuEigyoshoId = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, this.baseYmd).id
        }
      }
    },
    inputKosokuJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.kosokuJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kosokuJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.kosokuJikan)))
      }
    },
    inputZangyoJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.zangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'zangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.zangyoJikan)))
      }
    },
    inputShinyaJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.shinyaJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'shinyaJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.shinyaJikan)))
      }
    },
    inputShinyaZangyoJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'shinyaZangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.shinyaZangyoJikan)))
      }
    },
    inputKyukeiJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kyukeiJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan)))
      }
      this.inputAttendanceTimesElementJomuin()
    },
    inputKosokuJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.kosokuJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kosokuJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.kosokuJikan)))
      }
    },
    inputZangyoJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.zangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'zangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.zangyoJikan)))
      }
    },
    inputShinyaJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.shinyaJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'shinyaJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.shinyaJikan)))
      }
    },
    inputShinyaZangyoJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'shinyaZangyoJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.shinyaZangyoJikan)))
      }
    },
    inputKyukeiJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kyukeiJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan)))
      }
      this.inputAttendanceTimesElementJoshu()
    },
    inputYoteiSagyoJikan: function () {
      if (this.recHaisoMeisai.yoteiSagyoJikan) {
        this.$set(this.recHaisoMeisai, 'yoteiSagyoJikan', this.calcTime(String(this.recHaisoMeisai.yoteiSagyoJikan)))
      }
    },
    inputTaikiJikan: function () {
      if (this.recHaisoMeisai.taikiJikan) {
        this.$set(this.recHaisoMeisai, 'taikiJikan', this.calcTime(String(this.recHaisoMeisai.taikiJikan)))
      }
    },
    inputWarimashiTaishoJikan: function () {
      if (this.recHaisoMeisai.warimashiTaishoJikan) {
        this.$set(this.recHaisoMeisai, 'warimashiTaishoJikan', this.calcTime(String(this.recHaisoMeisai.warimashiTaishoJikan)))
      }
    },
    setJuchuEigyosho: function () {
      if (this.recHaisoMeisai.juchuEigyoshoId) {
        this.recHaisoMeisai.juchuEigyoshoCd = indexeddb.getRecord(this.eigyoshoList, this.recHaisoMeisai.juchuEigyoshoId).eigyoshoCd
      }
      // 履歴検索用受注営業所コード設定
      this.selectPopUpCondtion.juchuEigyoshoId = this.recHaisoMeisai.juchuEigyoshoId
    },
    inputKadouJikanJomuin: function () {
      if (this.viewsData.vwKintaiJissekiJomuin.kadouJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJomuin, 'kadouJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJomuin.kadouJikan)))
      }
    },
    inputKadouJikanJoshu: function () {
      if (this.viewsData.vwKintaiJissekiJoshu.kadouJikan) {
        this.$set(this.viewsData.vwKintaiJissekiJoshu, 'kadouJikan', this.calcTime(String(this.viewsData.vwKintaiJissekiJoshu.kadouJikan)))
      }
    },
    setYoshaInfo: function () {
      this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputYoshaInfo()

      if (this.viewsData.vwHaisoMeisai.length > 1) {
        const hacchusakiInfo = indexeddb.getRecord(this.torihikisakiList, this.viewsData.vwUnkoJisseki.hacchusakiId)
        const yoshaSharyoInfo = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId)
        const yoshaJininInfo = indexeddb.getRecord(this.eigyoshoJininList, this.viewsData.vwUnkoJisseki.hacchusakiJomuinId)

        this.viewsData.vwHaisoMeisai.forEach((meisai, mIndex) => {
          if (!meisai.motoukeFlg) return

          // 先頭のインデックスを取得
          const kIndex = meisai.jitsuUnsoTaiseiKanriList.findIndex(kanri => kanri.delFlg === false)

          if (kIndex === -1) return

          this.$set(
            this.viewsData.vwHaisoMeisai[mIndex].jitsuUnsoTaiseiKanriList,
            kIndex,
            {
              ...meisai.jitsuUnsoTaiseiKanriList[kIndex],
              jitsuUnsoJigyoshaNm: ![undefined, null, ''].includes(hacchusakiInfo) ? hacchusakiInfo.torihikisakiNm : '',
              jitsuUnsoSharyoNm: ![undefined, null, ''].includes(yoshaSharyoInfo) ? yoshaSharyoInfo.jidoshaHyojiNm : this.viewsData.vwUnkoJisseki.hacchusakiShaban,
              jitsuUnsoJomuinNm: ![undefined, null, ''].includes(yoshaJininInfo) ? yoshaJininInfo.jininNmSei : ''
            }
          )
        })
      }
    },
    setHinmei: function () {
      if (this.recHaisoMeisai.mstHinmeiId) {
        this.recHaisoMeisai.hinmeiCd = indexeddb.getRecord(this.hinmeiList, this.recHaisoMeisai.mstHinmeiId).hinmeiCd
      }
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputHinmei()
      }
    },
    setHatsuchiId: function () {
      if ([undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiId)) {
        this.recHaisoMeisai.hatsuchiYmd = ''
        this.recHaisoMeisai.hatsuchiHms = ''
      } else {
        this.recHaisoMeisai.hatsuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.recHaisoMeisai.hatsuchiId).hacchakuchiCd
      }
      if ([undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiYmd)) {
        this.recHaisoMeisai.hatsuchiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      }
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputHacchakuchi()
      }
    },
    setChakuchiId: function () {
      if ([undefined, null, ''].includes(this.recHaisoMeisai.chakuchiId)) {
        this.recHaisoMeisai.chakuchiYmd = ''
        this.recHaisoMeisai.chakuchiHms = ''
      } else {
        this.recHaisoMeisai.chakuchiCd = indexeddb.getRecord(this.hacchakuchiList, this.recHaisoMeisai.chakuchiId).hacchakuchiCd
      }
      if ([undefined, null, ''].includes(this.recHaisoMeisai.chakuchiYmd)) {
        this.recHaisoMeisai.chakuchiYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      }
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        this.$refs.dispJitsuUnsoTaiseiKanriListComponent.inputHacchakuchi()
      }
    },
    setHachhakuchiTanka: function (e) {
      let temp = Object.assign({}, this.recHaisoMeisai)
      temp = {
        ...temp,
        /*
        juchuEigyoshoId: e.eigyoshoCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', e.eigyoshoCd, this.baseYmd).id : temp.juchuEigyoshoId,
        tokuisakiId: e.torihikisakiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', e.torihikisakiCd, this.baseYmd).id : temp.tokuisakiId,
        mstHinmeiId: e.hinmeiCd ? indexeddb.getRecordByCd(this.currentKaishaCode, this.hinmeiList, 'hinmeiCd', e.hinmeiCd, this.baseYmd).id : temp.mstHinmeiId,
        seikyuShashuSbt: e.unchinShashuSbt,
        */
        unchinKeisanKbn: e.unchinKeisanKbn,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        hokanKingaku: e.userKingakuKazei4,
        niekiKingaku: e.userKingakuKazei3,
        unchinHokaKingaku: e.userKingakuKazei1,
        unchinHokaHikazei: e.userKingakuHikazei1,
        tatekaekinHikazei: e.userKingakuHikazei2,
        warimashiSonotaKingsku: e.userKingakuKazei2
      }
      this.recHaisoMeisai = Object.assign({}, temp)
      temp = undefined
    },
    setYoteiSokoKyori: function (e) {
      this.$set(this.recHaisoMeisai, 'yoteiSokoKyori', e.kyoriKm)
    },
    calcTime: function (p) {
      if (this.deleteMode !== 0) { return }
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    },
    // --------------------------------------------------------------------------------
    // 発着経由地入れ替え
    // --------------------------------------------------------------------------------
    onHatsuChakuReplace: function () {
      var tempHatsuChakuInfo = {
        hatsuchiId: this.recHaisoMeisai.hatsuchiId,
        hatsuchiBiko: this.recHaisoMeisai.hatsuchiBiko,
        keiyuchiId1: this.recHaisoMeisai.keiyuchiId1,
        keiyuchiBiko1: this.recHaisoMeisai.keiyuchiBiko1,
        keiyuchiId2: this.recHaisoMeisai.keiyuchiId2,
        keiyuchiBiko2: this.recHaisoMeisai.keiyuchiBiko2,
        keiyuchiId3: this.recHaisoMeisai.keiyuchiId3,
        keiyuchiBiko3: this.recHaisoMeisai.keiyuchiBiko3,
        keiyuchiId4: this.recHaisoMeisai.keiyuchiId4,
        keiyuchiBiko4: this.recHaisoMeisai.keiyuchiBiko4,
        keiyuchiId5: this.recHaisoMeisai.keiyuchiId5,
        keiyuchiBiko5: this.recHaisoMeisai.keiyuchiBiko5,
        chakuchiId: this.recHaisoMeisai.chakuchiId,
        chakuchiBiko: this.recHaisoMeisai.chakuchiBiko
      }

      // 既存値初期化
      this.recHaisoMeisai.hatsuchiId = null
      this.recHaisoMeisai.hatsuchiBiko = null
      this.recHaisoMeisai.keiyuchiId1 = null
      this.recHaisoMeisai.keiyuchiBiko1 = null
      this.recHaisoMeisai.keiyuchiId2 = null
      this.recHaisoMeisai.keiyuchiBiko2 = null
      this.recHaisoMeisai.keiyuchiId3 = null
      this.recHaisoMeisai.keiyuchiBiko3 = null
      this.recHaisoMeisai.keiyuchiId4 = null
      this.recHaisoMeisai.keiyuchiBiko4 = null
      this.recHaisoMeisai.keiyuchiId5 = null
      this.recHaisoMeisai.keiyuchiBiko5 = null
      this.recHaisoMeisai.chakuchiId = null
      this.recHaisoMeisai.chakuchiBiko = null

      if (![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiId) || ![undefined, null, ''].includes(tempHatsuChakuInfo.chakuchiBiko)) {
        this.recHaisoMeisai.hatsuchiId = tempHatsuChakuInfo.chakuchiId
        this.recHaisoMeisai.hatsuchiBiko = tempHatsuChakuInfo.chakuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiId) || ![undefined, null, ''].includes(tempHatsuChakuInfo.hatsuchiBiko)) {
        this.recHaisoMeisai.chakuchiId = tempHatsuChakuInfo.hatsuchiId
        this.recHaisoMeisai.chakuchiBiko = tempHatsuChakuInfo.hatsuchiBiko
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId5) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko5)) {
        this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId5
        this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko5
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId4) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko4)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId4
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko4
        } else {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId4
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko4
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId3) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko3)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko3
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko3
        } else {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId3
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko3
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId2) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko2)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko2
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko3)) {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko2
        } else {
          this.recHaisoMeisai.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId2
          this.recHaisoMeisai.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko2
        }
      }
      if (![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiId1) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko1)) {
        if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId1) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko1)) {
          this.recHaisoMeisai.keiyuchiId1 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko1 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId2) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko2)) {
          this.recHaisoMeisai.keiyuchiId2 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko2 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId3) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko3)) {
          this.recHaisoMeisai.keiyuchiId3 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko3 = tempHatsuChakuInfo.keiyuchiBiko1
        } else if ([undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiId4) || ![undefined, null, ''].includes(tempHatsuChakuInfo.keiyuchiBiko4)) {
          this.recHaisoMeisai.keiyuchiId4 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko4 = tempHatsuChakuInfo.keiyuchiBiko1
        } else {
          this.recHaisoMeisai.keiyuchiId5 = tempHatsuChakuInfo.keiyuchiId1
          this.recHaisoMeisai.keiyuchiBiko5 = tempHatsuChakuInfo.keiyuchiBiko1
        }
      }
    },
    // --------------------------------------------------------------------------------
    // GoogleMap表示
    // --------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiId) || ![undefined, null, ''].includes(this.recHaisoMeisai.hatsuchiBiko)) {
        const hatsuchi = {
          id: this.recHaisoMeisai.hatsuchiId,
          biko: this.recHaisoMeisai.hatsuchiBiko,
          ymdhms: '2999/12/31 00:00'
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }

      // 経由地１設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.Keiyuchi1Id) || ![undefined, null, ''].includes(this.recHaisoMeisai.keiyuchiBiko1)) {
        const Keiyuchi = {
          id: this.recHaisoMeisai.Keiyuchi1Id,
          biko: this.recHaisoMeisai.keiyuchiBiko1,
          ymdhms: '2999/12/31 00:00'
        }

        if (this.mapData.length > 0) {
          this.mapData.push(Keiyuchi)
        } else {
          this.mapData = [Keiyuchi]
        }
      }

      // 着地設定
      if (![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiId) || ![undefined, null, ''].includes(this.recHaisoMeisai.chakuchiBiko)) {
        const chakuchi = {
          id: this.recHaisoMeisai.chakuchiId,
          biko: this.recHaisoMeisai.chakuchiBiko,
          ymdhms: '2999/12/31 00:00'
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },
    copyUnkoYmd: function () {
      if (![undefined, null, ''].includes(this.viewsData.vwUnkoJisseki.sharyoId)) {
        this.viewsData.vwUnkoJisseki.jissekiShukkoYmd = this.viewsData.vwUnkoJisseki.unkoYmd
        this.viewsData.vwUnkoJisseki.jissekiKikoYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      }
      if (![undefined, null, ''].includes(this.viewsData.vwKintaiJissekiJomuin.jininId)) {
        this.viewsData.vwKintaiJissekiJomuin.shukkinYmd = this.viewsData.vwUnkoJisseki.unkoYmd
        this.viewsData.vwKintaiJissekiJomuin.taikinYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      }
      if (![undefined, null, ''].includes(this.viewsData.vwKintaiJissekiJoshu.jininId)) {
        this.viewsData.vwKintaiJissekiJoshu.shukkinYmd = this.viewsData.vwUnkoJisseki.unkoYmd
        this.viewsData.vwKintaiJissekiJoshu.taikinYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      }
    },
    copyJomuinKintai: function () {
      this.viewsData.vwKintaiJissekiJoshu.shukkinYmd = this.viewsData.vwKintaiJissekiJomuin.shukkinYmd
      this.viewsData.vwKintaiJissekiJoshu.shukkinHms = this.viewsData.vwKintaiJissekiJomuin.shukkinHms
      this.viewsData.vwKintaiJissekiJoshu.taikinYmd = this.viewsData.vwKintaiJissekiJomuin.taikinYmd
      this.viewsData.vwKintaiJissekiJoshu.taikinHms = this.viewsData.vwKintaiJissekiJomuin.taikinHms
      this.viewsData.vwKintaiJissekiJoshu.kosokuJikan = this.viewsData.vwKintaiJissekiJomuin.kosokuJikan
      this.viewsData.vwKintaiJissekiJoshu.kyukeiJikan = this.viewsData.vwKintaiJissekiJomuin.kyukeiJikan
      this.viewsData.vwKintaiJissekiJoshu.kadouJikan = this.viewsData.vwKintaiJissekiJomuin.kadouJikan
    },
    // --------------------------------------------------
    // IndexedDB取得
    // --------------------------------------------------
    getTeikeiInfo: function (teikeiKihonNo) {
      var teikeiCourse = this.teikeiCourseList.find((t) => {
        return t.teikeiKihonNo === teikeiKihonNo
      })
      return teikeiCourse
    },
    row_color_class: function (item) {
      return item.delFlg === true ? 'row_delete' : ''
    },
    onDummyFunction: function () {
      return null
    },
    // 明細一覧表調整
    calcWidthLineHeader () {
      var i
      const t = new Array(3) // this.widthOfLineHeader = []
      var tables = document.getElementsByTagName('table')
      var row = tables[0].getElementsByTagName('tr')[0].cells
      let width = 0
      for (i = 1; i <= 3; i++) {
        if (i === 1) {
          if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.kakuninzumiMode || this.filteredHaisoMeisaiListRows.length === 0) {
            t[i - 1] = 49
          } else {
            t[i - 1] = 162
          }
        } else {
          width = width + row[i].offsetWidth - 1
          t[i - 1] = width
        }
      }
      if (t.toString() !== this.widthOfLineHeader.toString()) {
        console.log('width changed')
        this.widthOfLineHeader = t
      }
    },
    onDetailEntryView: function () {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(2, { id: [this.id, this.keikakujissekikey] })
    }
  }
}
